const es = {
  // Common words and phrases
  common: {
    back: "Atrás",
    search: "Buscar",
    filter: "Filtrar",
    clear: "Limpiar",
    export: "Exportar",
    download: "Descargar",
    loading: "Cargando...",
    save: "Guardar",
    save_changes: "Guardar cambios",
    apply: "Aplicar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    view: "Ver",
    add: "Añadir",
    name: "Nombre",
    email: "Correo electrónico",
    password: "Contraseña",
    confirm: "Confirmar",
    submit: "Enviar",
    error: "Error",
    success: "Éxito",
    warning: "Advertencia",
    info: "Información",
    yes: "Sí",
    no: "No",
    all: "Todos",
    none: "Ninguno",
    select: "Seleccionar",
    for: "para",
    in: "en",
    showMore: "Mostrar más",
    showLess: "Mostrar menos",
    clearFilter: "Limpiar filtro",
    page: "Página",
    merchant: "Comerciante",
    institution: "Institución",
    account: "Cuenta",
    amount: "Cantidad",
    type: "Tipo",
    date: "Fecha",
    status: "Estado",
    action: "Acción",
    description: "Descripción",
    reference: "Referencia",
    balance: "Balance",
    increase: "Aumento",
    decrease: "Disminución",
    language: "Idioma",
    actions: "Acciones",
    group: "Grupo",
    category: "Categoría",
    transactions: "Transacciones",
    total: "Total",
    viewReport: "Ver informe",
    other: "Otro",
    selectCountries: "Seleccionar países",
    noCountryFound: "No se encontró ningún país.",
    currency: "Moneda",
    country: "País",
    continue: "Continuar",
    or: "o",
  },

  // Time related
  time: {
    today: "Hoy",
    yesterday: "Ayer",
    thisWeek: "Esta semana",
    lastWeek: "Semana pasada",
    thisMonth: "Este mes",
    lastMonth: "Mes pasado",
    thisYear: "Este año",
    lastYear: "Año pasado",
    custom: "Personalizado",
    from: "Desde",
    to: "Hasta",
    now: "Ahora",
    quarter: "Trimestre",
    year: "Año",
    month: "Mes",
    period: "Período",
    startMonth: "Mes de inicio",
    endMonth: "Mes de fin",
    startQuarter: "Trimestre de inicio",
    endQuarter: "Trimestre de fin",
    lastQuarter: "Últimos 90 días",
    allTime: "Todo el tiempo",
  },

  // Navigation and menus
  nav: {
    passiveIncome: "Ingresos pasivos",
    dashboard: "Panel",
    transactions: "Transacciones",
    accounts: "Cuentas",
    categories: "Categorías",
    reports: "Informes",
    settings: "Configuración",
    users: "Usuarios",
    logout: "Cerrar sesión",
    login: "Iniciar sesión",
    register: "Registrarse",
    profile: "Perfil",
    preferences: "Preferencias",
    help: "Ayuda",
    support: "Soporte",
    about: "Acerca de",
    currencyRates: "Tipos de cambio",
    financialSummary: "Resumen Financiero",
    portfolioHoldings: "Cartera de inversiones",
    tagAnalytics: "Análisis por etiquetas",
    equityAnalysis: "Análisis de acciones",
    expenses: "Gastos",
    agents: "Agentes Bliss",
    importAgent: "Agente de importación",
    insightAgent: "Insights de IA",
    travelAgent: "Agente de viajes",
    manageAssets: "Gestionar activos",
    assetsLiabilities: "Activos y pasivos",
    transactionReview: "Revisión de transacciones",
    subscriptions: "Suscripciones",
  },

  // Page titles and descriptions
  pages: {
    oauth: {
      consent: {
        title: "Conectar {{client}} a Bliss",
        subtitle: "Esta aplicación quiere usar tus datos de Bliss a través del servidor MCP.",
        signed_in_as: "Sesión iniciada como {{email}}",
        redirect_notice: "Cuando decidas, volverás a",
        access_label: "Acceso",
        read_only_description: "Ver transacciones, cartera, análisis e insights. No puede cambiar nada.",
        read_write_description: "Además, recategorizar transacciones, gestionar tus colas de revisión y editar datos de la cartera.",
        expiry_label: "La conexión caduca tras",
        no_expiry_warning: "Una conexión sin caducidad sigue funcionando hasta que la revoques.",
        footnote: "La aplicación ve tus datos financieros descifrados. Puedes revocar la conexión en cualquier momento en Ajustes → Integraciones.",
        admin_required: "Solo un administrador del espacio puede conectar aplicaciones. Pide a un administrador que la conecte.",
        allow: "Permitir",
        deny: "Rechazar",
        error_title: "No se puede completar esta conexión",
        error_missing: "Este enlace está incompleto. Vuelve a iniciar la conexión desde tu aplicación.",
        error_generic: "Algo salió mal. Vuelve a iniciar la conexión desde tu aplicación.",
      },
    },
    dashboard: {
      title: "Panel",
      subtitle: "Resumen de tu situación financiera",
      summary: "Resumen",
      recentTransactions: "Transacciones recientes",
      quickActions: "Acciones rápidas",
      insights: "Análisis",
      totalNetWorth: "Patrimonio neto total",
    },
    accounts: {
      title: "Cuentas",
      subtitle: "Gestiona tus cuentas financieras",
      addAccount: "Añadir cuenta",
      editAccount: "Editar cuenta",
      deleteAccount: "Eliminar cuenta",
      accountDetails: "Detalles de la cuenta",
      noAccounts: "No se encontraron cuentas",
      hasBeenRemoved: "ha sido eliminada",
    },
    transactions: {
      title: "Transacciones",
      subtitle: "Ver y gestionar tus transacciones",
      addTransaction: "Añadir transacción",
      editTransaction: "Editar transacción",
      deleteTransaction: "Eliminar transacción",
      transactionDetails: "Detalles de la transacción",
      noTransactions: "No se encontraron transacciones",
      filter: "Filtrar transacciones",
      import: "Importar transacciones",
      export: "Exportar transacciones",
      allAccounts: "Todas las cuentas",
      allGroups: "Todos los grupos",
      allCategories: "Todas las categorías",
      categoryGroup: "Grupo de categoría",
      exportCsv: "Exportar CSV",
      importCsv: "Importar CSV",
      exportComplete: "Exportación completa",
      csvDownloaded: "CSV descargado correctamente",
      exportFailed: "Error en la exportación",
      exporting: "Exportando...",
      exportTransactions: "Exportar transacciones",
      exportDescription: "Elige qué transacciones exportar",
      currentFilters: "{{count}} transacciones con los filtros actuales",
      allTransactions: "Todas las transacciones",
      exportingTransactions: "Exportando tus transacciones...",
      exportingNote: "Esto puede tardar un momento. No cierres este diálogo.",
      noTransactionsFound: "No se encontraron transacciones",
      tryDifferentFilters: "Intenta ajustar tus filtros para encontrar lo que buscas.",
      startDate: "Fecha de inicio",
      endDate: "Fecha de fin",
      pickDate: "Elegir fecha",
      editTransactionDescription: "Edita los detalles de esta transacción.",
      addTransactionDescription: "Completa los detalles para añadir una nueva transacción.",
    },
    categories: {
      title: "Categorías",
      subtitle: "Gestiona las categorías de transacciones",
      addCategory: "Añadir categoría",
      editCategory: "Editar categoría",
      deleteCategory: "Eliminar categoría",
      categoryDetails: "Detalles de la categoría",
      noCategories: "No se encontraron categorías",
    },
    reports: {
      title: "Informes",
      subtitle: "Selecciona un tipo de informe para obtener información financiera detallada",
      financialSummary: {
        title: "Resumen Financiero",
        description: "Ver ingresos y gastos en diferentes períodos"
      },
      expenses: {
        title: "Seguimiento de gastos",
        description: "Analizar patrones de gasto por categorías"
      },
      portfolio: {
        title: "Cartera de inversiones",
        description: "Ver y analizar tu cartera de inversiones"
      },
      recentReports: {
        title: "Informes recientes",
        description: "Tus informes generados recientemente",
        empty: "No se encontraron informes recientes.",
        hint: "Los informes que generes aparecerán aquí para acceso rápido."
      }
    },
    currencyRates: {
      title: "Tipos de cambio",
      subtitle: "Monitorear y gestionar tipos de cambio",
      baseCurrency: "Moneda base",
      targetCurrency: "Moneda objetivo",
      currentRate: "Tasa actual",
      historicalRates: "Tasas históricas",
      updateRate: "Actualizar tasa",
    },
    financialSummary: {
      title: "Resumen Financiero",
      subtitle: "Ver y analizar tus ingresos y gastos",
      statement: "Estado",
      trend: "Tendencia mensual",
      breakdown: "Desglose detallado de ingresos y gastos",
      chartDescription: "Desglose mensual de ingresos, gastos y ahorros",
      downloadStatement: "Descargar estado completo",
      netIncome: "Ingreso neto",
      netSavings: "Ahorro Neto",
      totalRevenue: "Ingresos totales",
      totalExpenses: "Gastos totales",
      savingsRate: "Tasa de Ahorro",
      topExpense: "Gasto principal",
      discretionaryIncome: "Ingreso Discrecional",
      savingsCapacity: "Capacidad de Ahorro",
      otherActivity: "Otra Actividad",
    },
    portfolio: {
      title: "Cartera de inversiones",
      description: "Rastrea y analiza tu cartera de inversiones por tipo de activo",
      subtitle: "Rastrea y analiza tu cartera de inversiones por tipo de activo",
      totalValue: "Valor total de la cartera",
      totalHoldings: "En {{count}} posiciones",
      gainLoss: "Ganancia/Pérdida total",
      overallReturn: "{{value}}% de rentabilidad total",
      assetBreakdown: "Desglose por clase de activo",
      holdings: "Lista de posiciones",
      allocation: "Asignación de activos",
      performance: "Rendimiento",
      holdingsDescription: "Tus inversiones agrupadas por tipo de activo",
      allocationDescription: "Distribución de tu cartera por tipo de activo",
      performanceDescription: "Comparación de ganancias y pérdidas por tipo de activo",
      search: "Buscar posiciones...",
      assetAndType: "Activo y tipo",
      symbolId: "Símbolo/ID",
      qtyUnits: "Cantidad/Unidades",
      currentPrice: "Precio actual",
      marketValue: "Valor de mercado",
      gainLossValue: "Ganancia/Pérdida",
      percentReturn: "% Rentabilidad"
    },
    expenses: {
      title: "Seguimiento de gastos",
      description: "Analiza tus patrones de gasto por categoría",
      selectCategoryType: "Seleccionar tipo de categoría",
      countriesSelected: "{{count}} países seleccionados",
      includeCredits: {
        label: "Incluir créditos",
        tooltip: "Activado: los créditos en categorías de gasto (reembolsos, devoluciones, la parte de un compañero de piso, indemnizaciones de seguros) se restan de los débitos. Desactivado: muestra solo los débitos."
      },
      basis: {
        net: "débitos − créditos",
        debitOnly: "solo débitos"
      },
      timeFrame: {
        label: "Período de tiempo",
        month: "Mes",
        quarter: "Trimestre",
        year: "Año"
      },
      export: "Exportar",
      metrics: {
        totalExpenses: "Gastos totales",
        averageMonthly: "Promedio mensual",
        highestCategory: "Categoría más alta",
        monthlyAverage: "Promedio mensual"
      },
      breakdown: {
        title: "Desglose de gastos",
        description: "Ver tus gastos por categoría",
        tabs: {
          byCategory: "Por categoría",
          monthlyTrends: "Tendencias mensuales",
          detailedList: "Lista detallada"
        },
        topCategories: "Principales categorías de gasto",
        netCredits: "Créditos netos",
        netCreditsCaption: "El total incluye {{amount}} de créditos netos",
        noNetSpend: "Sin gasto neto en este período",
        trendChart: {
          movingAverageSuffix: " (prom. 6 meses)"
        },
        comingSoon: {
          trends: "La vista de tendencias mensuales estará disponible pronto.",
          details: "La vista detallada de gastos estará disponible pronto."
        },
        details: {
          emptyTitle: "Selecciona una categoría para explorar",
          emptyDescription: "Haz clic en una porción del gráfico circular o en una fila de categoría para ver las transacciones individuales.",
          goToCategories: "Ir a Por categoría",
          capNotice: "Mostrando las primeras 1.000 transacciones; los totales pueden estar incompletos",
        }
      }
    },
    settings: {
      title: "Configuración de cuenta",
      description: "Gestiona las preferencias y configuración de tu cuenta",
      language: "Idioma",
      error_loading_reference_data: "Error al cargar datos de referencia. Actualiza la página.",
      error_saving_no_id: "No se pudo encontrar tu ID de usuario para guardar la configuración.",
      error_saving_generic: "Ocurrió un error desconocido al guardar.",
      success_saving: "Tu configuración se ha guardado correctamente.",
      tabs: {
        general: "General",
        countries_currencies: "Países y divisas",
        banks: "Bancos",
        connections: "Conexiones",
        integrations: "Integraciones",
        ai_classification: "Clasificación IA",
        maintenance: "Mantenimiento",
        admin_section: "Administración",
        processing: "Procesamiento",
        bank_sync: "Sincronización bancaria",
      },
      general: {
        title: "Configuración general",
        description: "Configura la información general de tu tenant",
        tenant_name_label: "Nombre del tenant",
        tenant_name_description: "Es el nombre de tu organización o perfil de finanzas personales.",
        user_management_label: "Gestión de usuarios",
        user_management_button: "Gestionar usuarios",
        user_management_description: "Gestiona los usuarios con acceso a tu cuenta tenant.",
        sign_out_others: {
          label: "Otros dispositivos",
          description: "Cierra la sesión en todas partes excepto en este dispositivo. Tus otros navegadores y apps instaladas tendrán que iniciar sesión de nuevo.",
          button: "Cerrar sesión en los demás dispositivos",
          confirm_title: "¿Cerrar sesión en los demás dispositivos?",
          confirm_description: "Todos los demás navegadores y apps instaladas con tu cuenta cerrarán sesión en su próxima solicitud. Este dispositivo sigue con la sesión iniciada.",
          confirm: "Cerrar las demás",
          success: "Se ha cerrado la sesión en los demás dispositivos.",
          error: "No se pudo cerrar la sesión en los demás dispositivos. Inténtalo de nuevo.",
        },
      },
      countries: {
        title: "Países",
        description: "Países donde tienes actividad financiera",
        selected_label: "Países seleccionados",
        available_label: "Países disponibles",
        none_selected: "No se han seleccionado países"
      },
      currencies: {
        title: "Divisas",
        description: "Divisas que utilizas en tus transacciones",
        selected_label: "Divisas seleccionadas",
        available_label: "Divisas disponibles",
        none_selected: "No se han seleccionado divisas"
      },
      banks: {
        title: "Configuración de bancos",
        description: "Gestiona los bancos que usas en tus actividades financieras",
        selected_label: "Tus bancos",
        available_label: "Bancos disponibles",
        none_selected: "No se han seleccionado bancos"
      },
      connections: {
        title: "Conexiones Plaid",
        description: "Gestiona tus conexiones bancarias vinculadas y su estado de sincronización",
        no_connections: "No hay conexiones bancarias. Usa 'Conectar banco' para vincular tu primera cuenta.",
        status_active: "Activo",
        status_login_required: "Se requiere inicio de sesión",
        status_error: "Error",
        status_revoked: "Revocado",
        status_pending: "Pendiente",
        last_sync: "Última sincronización",
        never_synced: "Nunca sincronizado",
        error_code: "Error",
        reconnect: "Reconectar",
        reconnect_description: "Vuelve a autenticar tu conexión bancaria para reanudar la sincronización.",
        connection_warning: "Una o más conexiones bancarias requieren atención.",
        accounts_linked: "cuentas vinculadas",
      },
      integrations: {
        title: "Integraciones y tokens de API",
        description: "Permite que agentes de IA, scripts y otros sistemas usen la API de Bliss. Cada integración tiene sus propios tokens, que puedes revocar en cualquier momento.",
        create: "Nueva integración",
        create_title: "Nueva integración",
        add_key_title: "Añadir una clave",
        rename_title: "Renombrar integración",
        empty: "Aún no hay integraciones. Crea una para conectar un agente de IA u otro sistema.",
        loading_error: "No se pudieron cargar las integraciones.",
        acting_note: "Las solicitudes con token actúan en tu nombre, limitadas al nivel de acceso que elijas. Si se elimina tu usuario, tus integraciones se revocan.",
        security_note: "Quien tenga un token puede ver tus datos financieros descifrados. Trátalo como la contraseña de tu banco.",
        access_read_only: "Solo lectura",
        access_read_write: "Lectura y escritura",
        access_read_only_description: "Puede leer transacciones, cartera, analíticas e insights. No puede cambiar nada.",
        access_read_write_description: "También puede crear y editar transacciones, etiquetas e importaciones, y gestionar la cola de revisión de Plaid. No puede gestionar cuentas, categorías, usuarios, conexiones bancarias ni ajustes.",
        status_active: "Activa",
        status_revoked: "Revocada",
        status_expired: "Caducada",
        keys_count: "{{count}} de {{total}} claves activas",
        last_used: "Último uso",
        never_used: "Nunca",
        expires: "Caduca",
        no_expiry: "Sin caducidad",
        add_key: "Añadir clave",
        revoke_key: "Revocar",
        revoke_integration: "Revocar integración",
        rename: "Renombrar",
        show_keys: "Claves",
        hide_keys: "Ocultar claves",
        form: {
          name_label: "Nombre",
          name_placeholder: "p. ej. Agente Claude",
          name_required: "Introduce un nombre.",
          description_label: "Descripción (opcional)",
          access_label: "Nivel de acceso",
          access_fixed: "El nivel de acceso no se puede cambiar después. Para cambiarlo, crea una nueva integración.",
          key_name_label: "Nombre de la clave (opcional)",
          key_name_placeholder: "p. ej. Portátil",
          expiry_label: "La clave caduca en",
          expiry_30: "30 días",
          expiry_90: "90 días",
          expiry_365: "1 año",
          expiry_never: "Nunca",
          no_expiry_warning: "Una clave sin caducidad sigue funcionando hasta que la revoques.",
          create_submit: "Crear integración",
          add_key_submit: "Crear clave",
          save: "Guardar",
          cancel: "Cancelar",
        },
        reveal: {
          title: "Copia tu token",
          subtitle: "Úsalo como token Bearer en la cabecera Authorization.",
          warning: "Este token no se volverá a mostrar. Guárdalo en un lugar seguro, como un gestor de contraseñas.",
          copy: "Copiar",
          copied: "Copiado",
          example: "Solicitud de ejemplo",
          done: "Hecho",
        },
        mcp: {
          title: "Usar con Claude (MCP)",
          description: "Conecta Claude Code u otro cliente MCP con esta clave. Verá los mismos datos que permite la clave: las claves de solo lectura solo pueden leer.",
          url_label: "URL del servidor MCP:",
          copy_command: "Copiar comando",
        },
        oauth: {
          badge: "Conectada vía OAuth · {{client}}",
          expires: "La conexión caduca el {{date}}",
          no_expiry: "La conexión no caduca",
        },
        confirm: {
          revoke_key_title: "¿Revocar esta clave?",
          revoke_key_description: "Todo lo que use esta clave dejará de funcionar en su próxima solicitud. Las demás claves de la integración siguen funcionando.",
          revoke_integration_title: "¿Revocar esta integración?",
          revoke_integration_description: "Todas sus claves dejan de funcionar de inmediato. No se puede deshacer.",
          confirm_revoke: "Revocar",
        },
        toast: {
          created: "Integración creada",
          key_created: "Clave creada",
          key_revoked: "Clave revocada",
          revoked: "Integración revocada",
          renamed: "Integración actualizada",
          error: "Algo ha salido mal. Inténtalo de nuevo.",
        },
      },
    },
    users: {
      title: "Usuarios",
      subtitle: "Gestionar cuentas de usuario y permisos",
      addUser: "Añadir usuario",
      editUser: "Editar usuario",
      deleteUser: "Eliminar usuario",
      userDetails: "Detalles del usuario",
      noUsers: "No se encontraron usuarios",
      roles: "Roles y permisos",
    },
    notFound: {
      title: "Página no encontrada",
      subtitle: "La página que buscas no existe",
      goBack: "Volver a la página de inicio",
    },
    login: {
      confirm_identity: {
        title: "Confirma que eres tú",
        description: "Por tu seguridad, confirma tu identidad para continuar. Es necesario cuando tu último inicio de sesión fue hace más de 15 minutos.",
        password_label: "Contraseña",
        confirm: "Confirmar",
        google: "Continuar con Google",
        divider: "o",
        wrong_password: "Contraseña incorrecta. Inténtalo de nuevo.",
        error: "No se pudo confirmar tu identidad. Inténtalo de nuevo.",
        no_method: "Esta cuenta no puede confirmar su identidad aquí. Cierra sesión, vuelve a iniciarla y reinténtalo.",
      },
      title: "Iniciar sesión",
      subtitle: "Accede a tu cuenta",
      noAccount: "¿No tienes cuenta?",
      signUp: "Regístrate",
      rememberMe: "Recuérdame",
    },
    agents: {
      title: "Agentes Bliss",
      subtitle: "Asistentes financieros potenciados por IA",
    },
    importAgent: {
      title: "Agente de importación",
      subtitle: "Importa y procesa datos financieros de diversas fuentes",
      description: "Sube y categoriza automáticamente transacciones de archivos CSV/PDF",
      dropzone: "Arrastra archivos aquí o haz clic para explorar",
      processing: "Procesando tus documentos",
      success: "Importado exitosamente",
      failed: "Error al importar",
      supportedFormats: "Formatos admitidos: CSV, PDF, Excel",
      parseOptions: "Opciones de análisis",
      mapColumns: "Mapear columnas",
      preview: "Vista previa de datos",
      import: "Importar datos",
    },
    insightAgent: {
      title: "Agente de análisis",
      subtitle: "Obtén análisis e recomendaciones financieras personalizadas",
      description: "Analiza tus patrones de gasto y recibe asesoramiento financiero adaptado",
      generating: "Generando análisis",
      noData: "Se necesitan más datos de transacciones para generar análisis",
      categories: "Análisis por categoría",
      trends: "Tendencias de gasto",
      recommendations: "Recomendaciones",
      savingOpportunities: "Oportunidades de ahorro",
      budgetSuggestions: "Sugerencias de presupuesto",
    },
    travelAgent: {
      title: "Agente de viajes",
      subtitle: "Gestiona tus gastos y presupuestos de viaje",
      description: "Planifica viajes, registra gastos y optimiza el gasto en viajes",
      upcoming: "Próximos viajes",
      past: "Viajes pasados",
      expenses: "Gastos de viaje",
      currency: "Conversión de divisas",
      planning: "Planificación de viajes",
      budgeting: "Presupuesto de viaje",
      addTrip: "Añadir viaje",
      editTrip: "Editar viaje",
    },
    comingSoon: {
      title: "Próximamente",
      subtitle: "Esta función está en desarrollo",
      description: "Estamos trabajando duro para traerte esta función. ¡Vuelve pronto!",
      backToHome: "Volver al panel",
    },
    manualUpdates: {
      title: "Activos y pasivos",
      subtitle: "Gestiona los precios de tus activos y las condiciones de deuda",
      assetsNeedingUpdate: "Activos que necesitan actualización de precio",
      liabilities: "Pasivos",
      noAssetsNeedUpdate: "Todos los activos están actualizados.",
      noLiabilities: "No se encontraron pasivos.",
      lastUpdated: "Última actualización",
      daysAgo: "hace {{count}} días",
      updatePrice: "Actualizar precio",
      editTerms: "Editar condiciones",
      errorLoading: "Error al cargar los datos de activos. Por favor, inténtalo de nuevo.",
    },
    profile: {
      title: "Perfil",
      subtitle: "Gestiona tu información personal",
    },
  },

  // Form fields and validation
  forms: {
    required: "Este campo es obligatorio",
    invalidEmail: "Por favor, introduce una dirección de correo electrónico válida",
    passwordLength: "La contraseña debe tener al menos 8 caracteres",
    passwordMismatch: "Las contraseñas no coinciden",
    invalidAmount: "Por favor, introduce una cantidad válida",
    invalidDate: "Por favor, introduce una fecha válida",
    maxLength: "Longitud máxima excedida",
    minLength: "Longitud mínima requerida",
    selectOption: "Por favor, selecciona una opción",
    invalidInput: "Entrada inválida",
  },

  // Dashboard cards and widgets
  dashboard: {
    totalBalance: "Balance total",
    income: "Ingresos",
    expenses: "Gastos",
    savings: "Ahorros",
    budget: "Presupuesto",
    recentTransactions: "Transacciones recientes",
    cashFlow: "Flujo de caja",
    netWorth: "Patrimonio neto",
    spendingByCategory: "Gastos de vida por categoría",
    topCategories: "Categorías principales",
    monthlyComparison: "Comparación mensual",
    viewAll: "Ver todo",
    viewMore: "Ver más",
    seeAll: "Ver todo",
    welcome: "Bienvenido de nuevo, {{name}}",
    quickActions: "Acciones rápidas",
    commonTasks: "Tareas comunes",
    syncedAccounts: "Cuentas sincronizadas",
    connected: "conectadas",
    allCurrent: "todas al día",
    noAccountsConnected: "No hay cuentas conectadas aún",
    connectMoreAccounts: "Conectar más cuentas",
    allConnectedAccounts: "Todas las cuentas conectadas",
    noTransactionsYet: "Sin transacciones aún",
    viewAllTransactions: "Ver todas las transacciones",
    live: "En vivo",
    actionNeeded: "Acción requerida",
  },

  // Charts and graphs
  charts: {
    period: "Período",
    value: "Valor",
    change: "Cambio",
    percentage: "Porcentaje",
    currency: "Moneda",
    category: "Categoría",
    amount: "Cantidad",
    date: "Fecha",
    trend: "Tendencia",
    average: "Promedio",
    total: "Total",
    count: "Cantidad",
    min: "Mínimo",
    max: "Máximo",
    distribution: "Distribución",
    comparison: "Comparación",
  },

  // Asset Types
  assetTypes: {
    Equity: {
      name: "Acciones",
      description: "Acciones, ETFs y otros valores de renta variable"
    },
    Crypto: {
      name: "Criptomonedas",
      description: "Bitcoin, Ethereum y otras criptomonedas"
    },
    RealEstate: {
      name: "Inmuebles",
      description: "Propiedades residenciales y comerciales"
    },
    Bonds: {
      name: "Bonos",
      description: "Bonos gubernamentales y corporativos"
    },
    PensionPlan: {
      name: "Plan de pensiones",
      description: "Planes de jubilación y pensiones"
    },
    Stocks: {
      name: "Acciones",
      description: "Acciones de empresas individuales"
    },
    Funds: {
      name: "Fondos",
      description: "Fondos mutuos y fondos de inversión"
    },
    ETFs: {
      name: "ETFs",
      description: "Fondos cotizados en bolsa"
    },
    Cash: {
      name: "Efectivo",
      description: "Efectivo y equivalentes"
    },
    Collectible: {
      name: "Coleccionables",
      description: "Arte, coleccionables y otros artículos únicos"
    },
    Vehicle: {
      name: "Vehículos",
      description: "Coches, barcos y otros vehículos"
    },
    Other: {
      name: "Otros",
      description: "Otros activos diversos"
    }
  },

  // Transaction types and categories
  transactions: {
    income: "Ingresos",
    expense: "Gasto",
    transfer: "Transferencia",
    investment: "Inversión",
    withdrawal: "Retiro",
    deposit: "Depósito",
    payment: "Pago",
    refund: "Reembolso",
    fee: "Comisión",
    tax: "Impuesto",
    dividend: "Dividendo",
    interest: "Interés",
    sale: "Venta",
    purchase: "Compra",
    other: "Otro",
    housing: "Vivienda",
    food: "Comida",
    transportation: "Transporte",
    utilities: "Servicios",
    healthcare: "Salud",
    personal: "Personal",
    entertainment: "Entretenimiento",
    education: "Educación",
    investments: "Inversiones",
    ventures: "Emprendimientos",
  },

  // Financial Summary specific
  financialSummary: {
    revenue: "Ingresos",
    assetTransfer: "Transferencia de activos",
    housingUtilities: "Vivienda y servicios",
    livingExpenses: "Gastos de vida",
    personalDevelopment: "Desarrollo personal",
    investments: "Inversiones",
    housing: "Vivienda",
    maintenance: "Mantenimiento",
    utilities: "Servicios",
    eatingOut: "Comidas fuera",
    eatingIn: "Comidas en casa",
    healthBeauty: "Salud y belleza",
    shopping: "Compras",
    entertainment: "Entretenimiento",
    travel: "Viajes",
    education: "Educación",
    skills: "Habilidades",
    international: "Internacional",
    domestic: "Nacional",
    laborIncome: "Ingresos laborales",
    taxes: "Impuestos",
    ventures: "Emprendimientos",
    angelInvestments: "Inversiones ángel",
    variableIncome: "Ingresos variables",
    gambling: "Juegos de azar",
    margin: "margen",
    netIncome: 'Ingresos netos',
    discretionaryIncome: 'Ingreso Discrecional',
    savingsCapacity: 'Capacidad de Ahorro',
    netSavings: 'Ahorro Neto',
    otherActivity: 'Otra Actividad',
    netInvested: "Inversión neta",
    netInvestedTooltip: "Dinero destinado a inversiones menos el dinero retirado (ventas, retiradas). Un valor positivo significa que invertiste más de lo que retiraste. No es una ganancia ni una pérdida.",
    netDebtRepaid: "Deuda neta amortizada",
    netDebtRepaidTooltip: "Deuda amortizada menos nuevos préstamos (por ejemplo, un préstamo ingresado por tu banco). Un valor positivo significa que redujiste tu deuda.",
    quarters: {
      q1: "T1",
      q2: "T2",
      q3: "T3",
      q4: "T4",
    },
  },

  // UI elements
  ui: {
    darkMode: "Modo oscuro",
    lightMode: "Modo claro",
    systemMode: "Modo sistema",
    close: "Cerrar",
    open: "Abrir",
    collapse: "Colapsar",
    expand: "Expandir",
    refresh: "Actualizar",
    retry: "Reintentar",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    warning: "Advertencia",
    info: "Información",
    notification: "Notificación",
    alert: "Alerta",
    dialogElement: "Diálogo",
    modal: "Modal",
    drawer: "Panel lateral",
    toast: "Notificación toast",
    tooltipElement: "Información emergente",
    badge: "Distintivo",
    avatar: "Avatar",
    icon: "Icono",
    button: "Botón",
    input: "Campo",
    select: "Selector",
    checkbox: "Casilla",
    radio: "Radio",
    toggle: "Interruptor",
    slider: "Deslizador",
    range: "Rango",
    datepicker: "Selector de fecha",
    timepicker: "Selector de hora",
    colorpicker: "Selector de color",
    filepicker: "Selector de archivo",
    pagination: "Paginación",
    table: "Tabla",
    list: "Lista",
    card: "Tarjeta",
    tabs: "Pestañas",
    accordion: "Acordeón",
    menu: "Menú",
    dropdown: "Desplegable",
    popover: "Ventana emergente",
    breadcrumb: "Ruta de navegación",
    navigation: "Navegación",
    sidebar: "Barra lateral",
    header: "Encabezado",
    footer: "Pie de página",
    content: "Contenido",
    layout: "Diseño",
    gridLayout: "Cuadrícula",
    column: "Columna",
    row: "Fila",
    section: "Sección",
    container: "Contenedor",
    wrapper: "Envoltorio",
    box: "Caja",
    flexbox: "Flexbox",
    stack: "Pila",
    group: "Grupo",
    divider: "Divisor",
    spacer: "Espaciador",
    separator: "Separador",
    spinner: "Cargando",
    progress: "Progreso",
    skeleton: "Esqueleto",
    placeholder: "Marcador",
    empty: "Vacío",
    fallback: "Alternativa",
    errorState: "Error",
    successState: "Éxito",
    warningState: "Advertencia",
    infoState: "Información",
    across: "En",
    upgradeToPro: "Actualizar a Pro",
    upgradeDescription: "Obtén análisis y funciones avanzadas",
    upgradeNow: "Actualizar ahora",
    edit: "Editar",
    delete: "Eliminar",
    deleting: "Eliminando...",
    cancel: "Cancelar",
    clearFilters: "Limpiar filtros",
    dialog: {
      deleteTitle: "Eliminar {{entity}}",
      deleteConfirmation: "¿Estás seguro de que quieres eliminar {{name}}? Esta acción no se puede deshacer."
    },
    entity: {
      category: "categoría",
      account: "cuenta",
      transaction: "transacción"
    },
  },

  // Notifications and alerts
  notifications: {
    success: {
      saved: "Guardado con éxito",
      updated: "Actualizado con éxito",
      deleted: "Eliminado con éxito",
      created: "Creado con éxito",
      uploaded: "Subido con éxito",
      sent: "Enviado con éxito",
      imported: "Importado con éxito",
      exported: "Exportado con éxito",
      downloaded: "Descargado con éxito",
      submitted: "Enviado con éxito",
    },
    error: {
      general: "Ha ocurrido un error",
      notFound: "No encontrado",
      serverError: "Error del servidor",
      validation: "Error de validación",
      unauthorized: "No autorizado",
      forbidden: "Prohibido",
      conflict: "Conflicto",
      network: "Error de red",
      generic: "Ha ocurrido un error. Por favor, inténtalo de nuevo.",
      server: "Error del servidor. Por favor, inténtalo más tarde.",
      timeout: "Tiempo de espera agotado. Por favor, inténtalo de nuevo.",
      badRequest: "Solicitud incorrecta. Por favor, revisa tus datos.",
      unavailable: "Servicio no disponible. Por favor, inténtalo más tarde.",
      tooManyRequests: "Demasiadas solicitudes. Por favor, inténtalo más tarde.",
    },
    warning: {
      unsavedChanges: "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir?",
      unsaved: "Cambios no guardados",
      deleteConfirmation: "¿Estás seguro de que quieres eliminar este elemento? Esta acción no se puede deshacer.",
      logout: "¿Estás seguro de que quieres cerrar sesión?",
      incomplete: "Algunos campos están incompletos",
      limitReached: "Has alcanzado el límite.",
      lowBalance: "Tu saldo es bajo.",
      expiringSoon: "Expira pronto.",
    },
    info: {
      noResults: "No se encontraron resultados.",
      empty: "No hay elementos para mostrar.",
      loading: "Cargando...",
      processingRequest: "Procesando tu solicitud...",
      newVersion: "Hay una nueva versión disponible.",
      comingSoon: "¡Próximamente!",
      maintenance: "Mantenimiento programado.",
    },
    center: {
      title: "Notificaciones",
      allCaughtUp: "Todo al día",
    },
  },

  accountForm: {
    accountName: "Nombre de la cuenta",
    accountNumber: "Número de cuenta",
    bank: "Banco / Institución",
    currency: "Moneda",
    country: "País",
    accountCreated: "Cuenta creada",
    accountCreatedSuccess: "{{name}} ha sido añadida a tus cuentas.",
    accountUpdated: "Cuenta actualizada",
    accountUpdatedSuccess: "La cuenta ha sido actualizada exitosamente.",
    createAccount: "Crear cuenta",
    updateAccount: "Actualizar cuenta",
    createError: "No se pudo crear la cuenta. Por favor, inténtalo de nuevo.",
    updateError: "No se pudo actualizar la cuenta. Por favor, inténtalo de nuevo.",
    selectBank: "Selecciona un banco",
    selectCurrency: "Selecciona una moneda",
    selectCountry: "Selecciona un país",
    addBank: "Añadir un nuevo banco",
    addBankError: "No se pudo añadir el banco. Por favor, inténtalo de nuevo.",
  },
  addBankDialog: {
    title: "Añadir un nuevo banco",
    description: "Introduce el nombre del banco que deseas añadir.",
    nameLabel: "Nombre del banco",
    namePlaceholder: "p. ej. Chase, Monzo, Revolut",
    validationError: "El nombre del banco debe tener entre 2 y 100 caracteres.",
  },
  categoryForm: {
    name: "Nombre de la categoría",
    type: "Tipo",
    group: "Grupo",
    categoryCreated: "Categoría creada",
    categoryCreatedSuccess: "{{name}} ha sido añadida a tus categorías.",
    categoryUpdated: "Categoría actualizada",
    categoryUpdatedSuccess: "La categoría ha sido actualizada exitosamente.",
    createCategory: "Crear categoría",
    updateCategory: "Actualizar categoría",
    createError: "No se pudo crear la categoría. Por favor, inténtalo de nuevo.",
    updateError: "No se pudo actualizar la categoría. Por favor, inténtalo de nuevo.",
  },
  transactionForm: {
    date: "Fecha",
    transactionType: "Tipo de transacción",
    description: "Descripción",
    amount: "Cantidad",
    fromAccount: "Desde la cuenta",
    account: "Cuenta",
    toAccount: "A la cuenta",
    category: "Categoría",
    notes: "Notas (opcional)",
    transactionCreated: "Transacción creada",
    transactionCreatedSuccess: "Nueva transacción registrada.",
    transactionUpdated: "Transacción actualizada",
    transactionUpdatedSuccess: "La transacción ha sido actualizada exitosamente.",
    createTransaction: "Crear transacción",
    updateTransaction: "Actualizar transacción",
    createError: "No se pudo crear la transacción. Por favor, inténtalo de nuevo.",
    updateError: "No se pudo actualizar la transacción. Por favor, inténtalo de nuevo.",
  },
  userForm: {
    email: "Correo electrónico",
    userCreated: "Usuario creado",
    userCreatedSuccess: "{{email}} ha sido invitado a tu equipo.",
    userUpdated: "Usuario actualizado",
    userUpdatedSuccess: "El usuario ha sido actualizado exitosamente.",
    inviteUser: "Invitar usuario",
    updateUser: "Actualizar usuario",
    createError: "Error al crear el usuario. Por favor, inténtelo de nuevo.",
    updateError: "Error al actualizar el usuario. Por favor, inténtelo de nuevo.",
  },

  defaultCategories: {
    names: {
      OPERATING_CASH: "Efectivo operativo",
      STOCKS: "Acciones",
      INVESTMENT_FUNDS: "Fondos",
      ETFS: "ETFs",
      COPY_TRADING: "Copy Trading",
      PENSION_PLAN: "Plan de pensiones",
      GOVERNMENT_BONDS: "Bonos gubernamentales",
      CORPORATE_BONDS: "Bonos corporativos",
      CRYPTO: "Criptomonedas",
      REAL_ESTATE: "Inmuebles",
      COLLECTIBLE: "Coleccionables",
      VEHICLE: "Vehículo",
      COMMODITIES: "Materias primas",
      PRIVATE_EQUITY: "Capital privado",
      MORTGAGE: "Hipoteca",
      CREDIT_CARD_DEBT: "Deuda de tarjeta de crédito",
      ALLOWANCE: "Asignación",
      RENT_INCOME: "Ingresos por alquiler",
      SALARY: "Salario",
      FREELANCE_INCOME: "Ingresos por Trabajo Independiente",
      BONUS: "Bono",
      COMMISSION: "Comisión",
      GOVERNMENT_WELFARE: "Ayudas gubernamentales",
      TAXES: "Impuestos",
      TAX_REFUND: "Devolución de Impuestos",
      DIVIDENDS: "Dividendos",
      BOND_INCOME: "Ingresos por bonos",
      INTEREST_INCOME: "Ingresos por intereses",
      OPTIONS_INCOME: "Ingresos por opciones",
      RENT: "Alquiler",
      HOA_COMMUNITY_FEES: "Cuotas de comunidad",
      SECURITY_DEPOSIT: "Depósito de seguridad",
      HOME_INSURANCE: "Seguro del hogar",
      POWER_AND_GAS: "Electricidad y gas",
      WATER: "Agua",
      DATA_PLAN: "Plan de datos",
      INTERNET: "Internet",
      CLEANING_SERVICE: "Servicio de limpieza",
      HOME_IMPROVEMENT: "Mejoras del hogar",
      GROCERIES: "Supermercado",
      CONVENIENCE_STORES: "Tiendas de conveniencia",
      DOCTOR: "Médico",
      HEALTH_INSURANCE: "Seguro de salud",
      PHARMACY: "Farmacia",
      BIKING: "Bicicleta",
      FUEL_AND_GAS: "Combustible y gas",
      VEHICLE_MAINTENANCE: "Mantenimiento del vehículo",
      VEHICLE_TAXES_AND_TICKETS: "Impuestos y multas de vehículo",
      VEHICLE_INSURANCE: "Seguro del vehículo",
      METRO: "Metro",
      PARKING: "Estacionamiento",
      TAXI: "Taxi",
      TRAINS: "Trenes",
      BUS: "Autobús",
      PET_CARE: "Cuidado de mascotas",
      PET_FOOD: "Comida para mascotas",
      PET_INSURANCE: "Seguro de mascotas",
      BANKING_FEES: "Comisiones bancarias",
      DOCUMENTATION: "Documentación",
      NOTARY: "Notaría",
      ACCOUNTING: "Contabilidad",
      BUSINESS_MEAL: "Comida de negocios",
      RESTAURANTS: "Restaurantes",
      BAKERY_AND_COFFEE: "Panadería y café",
      FOOD_DELIVERY: "Comida a domicilio",
      BAR: "Bar",
      NIGHTCLUB: "Discoteca",
      CONCERTS: "Conciertos",
      MOVIES_AND_THEATER: "Cine y teatro",
      OUTDOOR_ACTIVITIES: "Actividades al aire libre",
      SPORTING_EVENTS: "Eventos deportivos",
      GAMBLING: "Juegos de azar",
      GAMING: "Videojuegos",
      BEAUTY: "Belleza",
      HAIRCARE: "Peluquería",
      SPORTS_AND_GYM: "Deportes y gimnasio",
      SHOPPING: "Compras",
      ELECTRONICS: "Electrónica",
      FURNITURE_AND_DIY: "Muebles y bricolaje",
      CLOTHES_AND_FASHION: "Ropa y moda",
      GIFTS: "Regalos",
      JEWELRY: "Joyería",
      DECORATION_AND_TEXTILES: "Decoración y textiles",
      KITCHENWARE: "Menaje de cocina",
      SOFTWARE: "Software",
      CONTENT_AND_MEDIA: "Contenido y medios",
      LOYALTY_PROGRAMS: "Programas de fidelidad",
      CASH_AT_ATM: "Efectivo en cajero",
      INHERITANCE: "Herencia",
      RECEIVED_DOMESTIC: "Transferencia Recibida — Nacional",
      RECEIVED_INTERNATIONAL: "Transferencia Recibida — Internacional",
      SENT_DOMESTIC: "Transferencia Enviada — Nacional",
      SENT_INTERNATIONAL: "Transferencia Enviada — Internacional",
      BIZ_SALES_REVENUE: "Ingresos por ventas",
      BIZ_SERVICE_REVENUE: "Ingresos por servicios",
      BIZ_REFERRAL_INCOME: "Referidos y afiliados",
      BIZ_INVENTORY: "Inventario y materiales",
      BIZ_SHIPPING: "Envíos y logística",
      BIZ_SAAS: "SaaS y herramientas",
      BIZ_CLOUD: "Nube y alojamiento",
      BIZ_MARKETING: "Marketing y publicidad",
      BIZ_DATA_SERVICES: "Datos y servicios API",
      BIZ_OFFICE: "Oficina y espacio de trabajo",
      BIZ_DOMAINS: "Dominios y licencias",
      BIZ_EQUIPMENT: "Equipamiento empresarial",
      BIZ_OTHER_COSTS: "Otros costes empresariales",
      BIZ_FREELANCERS: "Freelancers y contratistas",
      BIZ_PROFESSIONAL_SERVICES: "Servicios profesionales",
      BIZ_TAXES: "Impuestos empresariales e IVA",
      BIZ_CAPITAL: "Inyección de capital",
      MUSIC: "Instrumentos musicales",
      THERAPY_AND_COUNSELING: "Terapia y asesoramiento",
      MENTORING: "Coaching y mentoría",
      SCHOOL: "Escuela",
      ONLINE_COURSES: "Cursos en línea",
      TRAVEL_TRANSPORT: "Transporte de viaje",
      ACCOMMODATION: "Alojamiento",
      CAR_RENTAL: "Alquiler de coche",
      TOURS_AND_ACTIVITIES: "Tours y actividades",
      TRAVEL_EXPENSES: "Gastos de viaje",
      DONATIONS: "Donaciones",
      BOOKS: "Libros",
    },
    descriptions: {
      SENT_DOMESTIC: "Dinero que enviaste a alguien dentro de tu país — devoluciones a amigos, transferencias entre tus propias cuentas, o cualquier débito que no sea una compra.",
      SENT_INTERNATIONAL: "Dinero que enviaste al extranjero — transferencias a familia, a tus propias cuentas en el extranjero, o cualquier débito transfronterizo que no sea una compra.",
      RECEIVED_DOMESTIC: "Dinero recibido de alguien dentro de tu país — devoluciones de amigos, transferencias entre tus propias cuentas, u otros créditos que no sean ingresos.",
      RECEIVED_INTERNATIONAL: "Dinero recibido del extranjero — regalos de familia, transferencias desde tus propias cuentas en el extranjero, u otros créditos transfronterizos que no sean ingresos.",
      BIZ_SERVICE_REVENUE: "Ingresos por servicios prestados por tu propio negocio o proyecto secundario. Si trabajas como autónomo y es tu trabajo principal en lugar de un negocio paralelo, usa Ingresos por Trabajo Independiente (en Ingresos del Trabajo).",
      BIZ_SALES_REVENUE: "Ingresos por ventas de bienes de tu propio negocio o proyecto secundario.",
      BIZ_OTHER_REVENUE: "Otras fuentes de ingresos de tu propio negocio o proyecto secundario — licencias, regalías, pagos de socios, etc.",
      ALLOWANCE: "Dinero de bolsillo, mesadas o apoyo familiar continuo. Útil para estudiantes y para usar Bliss en aulas donde los usuarios registran dinero recibido de su familia.",
      GOVERNMENT_WELFARE: "Pagos de transferencia del gobierno — subsidio de desempleo, prestaciones por hijos, seguridad social o similares. No son ingresos laborales.",
      INHERITANCE: "Dinero o activos heredados de un familiar fallecido. Clasificado en Transferencias porque es un ingreso único e irregular, no un ingreso laboral o de inversión — mantenerlo aquí evita distorsionar las tendencias anuales.",
      FREELANCE_INCOME: "Ingresos de trabajo freelance o consultoría tratado como tu trabajo principal. Si es un negocio paralelo con su propia contabilidad, usa Ingresos por Servicios (en Empresas).",
      BONUS: "Bonos anuales, trimestrales o puntuales pagados por tu empleador. A menudo se gravan de forma diferente al salario regular — separarlo facilita la lectura de las tendencias de ingresos.",
      COMMISSION: "Comisiones por ventas u otra remuneración por desempeño vinculada a los ingresos que generaste.",
      TAX_REFUND: "Devolución recibida de la autoridad tributaria por un pago en exceso en un período anterior.",
    },
    groups: {
      Cash: "Efectivo",
      Stocks: "Acciones",
      Funds: "Fondos",
      ETFs: "ETFs",
      "Pension Plan": "Plan de pensiones",
      Bonds: "Bonos",
      Crypto: "Criptomonedas",
      "Real Estate": "Inmuebles",
      Collectible: "Coleccionables",
      "Depreciating assets": "Activos depreciables",
      Commodities: "Materias primas",
      "Private Equity": "Capital privado",
      "Real Estate Loan": "Préstamo inmobiliario",
      "Personal Debt": "Deuda personal",
      "Passive Income": "Ingresos pasivos",
      "Labor Income": "Ingresos laborales",
      Taxes: "Impuestos",
      Housing: "Vivienda",
      Utilities: "Servicios",
      "Home Maintenance": "Mantenimiento del hogar",
      "Eating In": "Comer en casa",
      Healthcare: "Salud",
      Transportation: "Transporte",
      Pets: "Mascotas",
      Finance: "Finanzas",
      Civil: "Civil",
      "Dining Out": "Comer fuera",
      Entertainment: "Entretenimiento",
      "Wellness & Beauty": "Bienestar y belleza",
      "Shopping & Gifts": "Compras y regalos",
      Subscriptions: "Suscripciones",
      Misc: "Varios",
      Inheritance: "Herencia",
      Domestic: "Nacional",
      International: "Internacional",
      Revenue: "Ingresos",
      "Cost of Goods Sold": "Coste de mercancías",
      "Operating Expenses": "Gastos operativos",
      "People & Services": "Personas y servicios",
      Capital: "Capital",
      Skills: "Habilidades",
      "Mental Health": "Salud mental",
      Education: "Educación",
      Travel: "Viajes",
      Donations: "Donaciones",
      Other: "Otro",
      Others: "Otros",
      "N/A": "N/A",
    },
    types: {
      Income: "Ingresos",
      Essentials: "Esenciales",
      Lifestyle: "Estilo de vida",
      Growth: "Crecimiento",
      Ventures: "Emprendimientos",
      Investments: "Inversiones",
      Asset: "Activo",
      Debt: "Deuda",
      Transfers: "Transferencias",
    },
    processingHints: {
      API_STOCK: "API de precios de acciones",
      API_CRYPTO: "API de precios de cripto",
      API_FUND: "API de precios de fondos",
      AMORTIZING_LOAN: "Seguimiento de préstamo",
      SIMPLE_LIABILITY: "Seguimiento de pasivo",
      CASH: "Seguimiento de efectivo",
      MANUAL: "Manual",
      TAX_DEDUCTIBLE: "Deducible de impuestos",
      DEBT: "Seguimiento de deuda",
      COPY_TRADING: "Copy Trading de eToro",
    },
  },

  accountsPage: {
    title: "Cuentas",
    subtitle: "Gestiona tus conexiones bancarias y cuentas manuales.",
    connectBank: "Conectar banco",
    addManual: "Añadir cuenta manual",
    selectAccount: "Selecciona una cuenta",
    selectAccountHint: "Elige una cuenta de la lista para ver los detalles de conexión, registros de sincronización y acciones de gestión.",
    deleteTitle: "Eliminar cuenta",
    deleteConfirm: "¿Estás seguro de que quieres eliminar \"{{name}}\"? Esta acción no se puede deshacer.",
    deleteSuccess: "Cuenta eliminada",
    deleteSuccessDetail: "{{name}} ha sido eliminada.",
    deleteFailed: "Error al eliminar la cuenta",
    deleteAction: "Eliminar cuenta",
    dangerZone: "Zona de peligro",
    deleteBlockedTransactions_one: "Esta cuenta tiene {{count}} transacción vinculada y no se puede eliminar hasta que la elimines o la reasignes a otra cuenta.",
    deleteBlockedTransactions_other: "Esta cuenta tiene {{count}} transacciones vinculadas y no se puede eliminar hasta que las elimines o las reasignes a otra cuenta.",
    deleteBlockedTransactions: "Esta cuenta tiene {{count}} transacciones vinculadas y no se puede eliminar hasta que las elimines o las reasignes a otra cuenta.",
    deleteBlockedPlaid: "Esta cuenta sigue conectada a tu banco. Primero desconecta la conexión bancaria y luego elimina la cuenta.",
    deleteBlockedPlaidHint: "Primero desconecta esta conexión bancaria (usa «Pausar sincronización» arriba) antes de eliminar la cuenta.",
    deleteUnknownError: "No se pudo eliminar esta cuenta. Inténtalo de nuevo.",
    searchAccounts: "Buscar cuentas...",
    noAccountsMatch: "Ninguna cuenta coincide con tu búsqueda.",
    noAccountsYet: "Aún no hay cuentas.",
    synced: "Sincronizada",
    actionRequired: "Acción requerida",
    disconnected: "Desconectada",
    manual: "Manual",
  },

  accountDetail: {
    edit: "Editar",
    plaidConnected: "Conectado por Plaid",
    placeholderNumberHint: "Esta cuenta todavía tiene un número provisional de la configuración.",
    addAccountNumber: "Añade el número de cuenta real",
    connectionHealth: "Estado de conexión",
    consentExpired: "Consentimiento expirado",
    consentExpiringSoon: "Consentimiento por expirar",
    consentExpiredOn: "Tu consentimiento bancario expiró el {{date}}. Reconecta para reanudar la sincronización.",
    consentExpiresOn: "Tu consentimiento bancario expira el {{date}} ({{days}} día restante). Reconecta antes para evitar interrupciones.",
    consentExpiresOnPlural: "Tu consentimiento bancario expira el {{date}} ({{days}} días restantes). Reconecta antes para evitar interrupciones.",
    reconnect: "Reconectar",
    disconnectedMessage: "Esta conexión bancaria fue desconectada. Vuelve a vincular para reanudar la sincronización de transacciones.",
    reconnectBank: "Reconectar banco",
    actions: "Acciones",
    resyncNow: "Resincronizar ahora",
    rotateToken: "Rotar token",
    relinkPlaid: "Revincular Plaid",
    pauseSync: "Pausar sincronización",
    security: "Seguridad",
    securityEncryption: "Todos los datos de la cuenta están cifrados en reposo con AES-256-GCM.",
    securityTokens: "Los tokens de acceso de Plaid se rotan periódicamente y se almacenan cifrados.",
    pauseSyncDescription: "Esto pausará la sincronización de esta cuenta. Tus transacciones existentes e historial de conexión no se verán afectados. Puedes reconectar en cualquier momento.",
    disconnect: "Desconectar",
    disconnecting: "Desconectando...",
    syncTriggered: "Sincronización iniciada",
    syncTriggeredDetail: "Se ha iniciado una nueva sincronización para esta cuenta.",
    syncFailed: "Error al iniciar la sincronización",
    tokenRotated: "Token rotado",
    tokenRotatedDetail: "El token de acceso se ha rotado correctamente.",
    tokenRotateFailed: "Error al rotar el token",
    disconnected: "Desconectada",
    disconnectedDetail: "La conexión bancaria ha sido eliminada.",
    disconnectFailed: "Error al desconectar",
    securityDesc: "Todos los datos de la cuenta están cifrados en reposo con AES-256-GCM.",
    securityPlaid: "Los tokens de acceso de Plaid se rotan periódicamente y se almacenan cifrados.",
    syncTriggeredDesc: "Se ha iniciado una nueva sincronización para esta cuenta.",
    tokenRotatedDesc: "El token de acceso se ha rotado correctamente.",
    disconnectedDesc: "La conexión bancaria ha sido eliminada.",
    reconnectDesc: "Esta conexión bancaria fue desconectada. Vuelve a vincular para reanudar la sincronización.",
    pauseSyncTitle: "Pausar sincronización",
    pauseSyncDesc: "Esto pausará la sincronización de esta cuenta. Tus transacciones existentes e historial de conexión no se verán afectados. Puedes reconectar en cualquier momento.",
    consentExpiredDesc: "Tu consentimiento bancario expiró el {{date}}. Reconecta para reanudar la sincronización.",
    consentExpiringSoonDesc: "Tu consentimiento bancario expira el {{date}} ({{days}} días restantes). Reconecta antes para evitar interrupciones.",
  },

  accountModal: {
    editTitle: "Editar cuenta",
    addTitle: "Añadir cuenta manual",
    editDescription: "Actualiza los detalles de tu cuenta.",
    addDescription: "Añade una nueva cuenta de seguimiento manual.",
  },

  connectionHealth: {
    status: "Estado",
    lastSynced: "Última sincronización",
    nextSync: "Próxima sincronización",
    approxInterval: "~6 horas",
    historyRange: "Rango de historial",
    notYetSynced: "Aún no sincronizado",
    historyStatus: "Estado del historial",
    complete: "Completo",
    syncingHistory: "Sincronizando historial completo...",
    institutionId: "ID de institución",
    connection: "Conexión",
    manualEntry: "Entrada manual",
    fetchOlder: "Obtener transacciones antiguas",
    selectStartDate: "Selecciona una fecha de inicio (hasta 2 años atrás)",
    fetchFrom: "Obtener desde",
    selectDate: "Selecciona una fecha",
    title: "Estado de conexión",
    backfillStarted: "Recuperación iniciada",
    backfillDetail: "Obteniendo transacciones desde {{date}}. Esto puede tardar un momento.",
    backfillFailed: "Error al iniciar la recuperación",
    nextSyncValue: "~6 horas",
    fetching: "Obteniendo...",
    never: "Nunca",
    justNow: "Ahora mismo",
    minutesAgo: "hace {{count}}m",
    hoursAgo: "hace {{count}}h",
    daysAgo: "hace {{count}}d",
    today: "Hoy",
    fetchOlderTransactions: "Obtener transacciones anteriores",
  },

  review: {
    confident: "Segura",
    newMerchant: "Nuevo comerciante",
    actionNeeded: "Acción requerida",
    uncertain: "Incierta",
    duplicate: "Duplicada",
    possibleDup: "Posible dup.",
    approveAll: "Aprobar todo",
    date: "Fecha",
    merchant: "Comerciante",
    account: "Cuenta",
    amount: "Cantidad",
    confidence: "Conf.",
    status: "Estado",
    actions: "Acciones",
    uncategorized: "Sin categoría",
    required: "Requerido",
    selectAccount: "Seleccionar cuenta",
    noAccount: "Sin cuenta",
    investmentEnrichmentRequired: "Se requiere información de inversión para esta categoría. Por favor, completa el ticker, la cantidad y el precio.",
    investmentEnrichmentRequiredTickerOptional: "Se requiere información de inversión para esta categoría. Completa la cantidad y el precio; el ticker es opcional para fondos no cotizados.",
    currencyMismatch: "Este activo cotiza en {{assetCurrency}} pero la transacción es en {{txCurrency}}. Los valores del portafolio pueden requerir conversión de moneda.",
    detailsNotes: "Detalles / Notas",
    optionalNotes: "Notas opcionales",
    tags: "Etiquetas",
    skip: "Omitir",
    merchantHistory: "Historial del comerciante",
    noMerchantHistory: "No se encontraron transacciones anteriores de este comerciante.",
    blissAnalysis: "Análisis Bliss",
    aiConfidence: "Confianza IA",
    source: "Fuente",
    plaidCategory: "Categoría Plaid",
    classificationReasoning: "Razonamiento de clasificación",
    whyChose: "Por qué elegí esto",
    sourceLabels: {
      USER_OVERRIDE: "Establecido por ti",
      EXACT_MATCH: "Coincidencia del historial",
      VECTOR_MATCH: "Similar a tu historial",
      VECTOR_MATCH_GLOBAL: "Coincidencia de la comunidad",
      LLM: "Clasificación por IA",
      PLAID_HINT: "Sugerido por el banco",
      default: "Análisis IA",
    },
    enrichmentRequired: "Información requerida",
    enrichmentDescription: "Esta transacción parece relacionada con inversiones. Proporciona los detalles a continuación para un seguimiento correcto en tu portafolio.",
    tickerSymbol: "Símbolo del ticker",
    tickerOptional: "opcional",
    tickerPlaceholder: "ej. VWCE, AAPL",
    pricePerShare: "Precio por acción",
    pricePlaceholder: "ej. 43.67",
    quantity: "Cantidad",
    quantityAuto: "(auto)",
    quantityCalculated: "Calculado automáticamente",
    quantityPlaceholder: "ej. 1.23",
    notesPlaceholder: "Notas opcionales (reemplaza la descripción predeterminada de la transacción)",
    selectCategory: "Por favor, selecciona una categoría",
    selectDate: "Por favor, selecciona una fecha",
    descriptionRequired: "La descripción es obligatoria",
    selectCurrency: "Por favor, selecciona una moneda",
    selectAccountValidation: "Por favor, selecciona una cuenta",
    pageTitle: "Revisión de Transacciones",
    pageSubtitle: "Revisa y aprueba transacciones pendientes de todas las fuentes.",
    requeueSkipped: "Reencolar Omitidas",
    bulkPromote: "Promover en Lote",
    reviewedProgress: "{{done}} de {{total}} revisadas",
    allPending: "Todas Pendientes",
    fromPlaid: "De Plaid",
    fromImports: "De Importaciones",
    allCaughtUp: "¡Todo al día!",
    noPendingTransactions: "No hay transacciones pendientes para revisar.",
    plaidTransactions: "Transacciones de Plaid",
    importTransactions: "Transacciones de Importación",
    pending: "pendientes",
    cancelImport: "Cancelar importación",
    noPlaidToReview: "No hay transacciones de Plaid para revisar",
    allPlaidProcessed: "Todas las transacciones de Plaid han sido procesadas.",
    noPendingImports: "No hay importaciones pendientes",
    allImportsCommitted: "Todas las importaciones han sido confirmadas.",
    committingTransactions: "Confirmando Transacciones...",
    complete: "completado",
    noRowsInImport: "No hay filas en esta importación.",
    committing: "Confirmando...",
    commitAll: "Confirmar Todo",
    selectCategoryPlaceholder: "Seleccionar categoría",
    saveChanges: "Guardar Cambios",
    saveAndPromote: "Guardar y Promover",
    resetToPending: "Volver a Pendiente",
    resetToPendingDesc: "Mueve esta fila a pendiente para que no se confirme automáticamente. Útil para deshacer una clasificación auto-promovida que quieres revisar.",
    bulkPromoteTitle: "Promover Transacciones en Lote",
    bulkPromoteDescription: "Promover automáticamente todas las transacciones clasificadas de Plaid que superen el umbral de confianza.",
    minConfidenceThreshold: "Umbral Mínimo de Confianza",
    threshold90: "90% (Más conservador)",
    threshold80: "80% (Recomendado)",
    threshold70: "70%",
    threshold50: "50% (Menos conservador)",
    thresholdHint: "Solo se promoverán las transacciones con una confianza de IA igual o superior a este umbral.",
    promoteAll: "Promover Todo",
    promoting: "Promoviendo...",
    promoteMatchingTitle: "¿Promover transacciones coincidentes?",
    promoteMatchingDescription: "Se encontraron <strong>{{count}} transacción(es) pendiente(s)</strong> con el nombre \"{{description}}\".",
    justThisOne: "Solo esta",
    promoteAllCount: "Promover todas {{count}}",
    confirmMatchingTitle: "¿Confirmar también transacciones coincidentes?",
    confirmMatchingDescription: "Hay <strong>{{count}} otra(s) transacción(es) pendiente(s)</strong> con el nombre \"{{description}}\". ¿Confirmarlas todas como <strong>{{category}}</strong>?",
    confirmAllCount: "Confirmar todas {{count}}",
    confirming: "Confirmando...",
    pageOf: "Página {{current}} de {{total}}",
    unknown: "Desconocido",
    // Fallo de clasificación y reintento
    classificationFailed: "Clasificación fallida",
    retryClassification: "Reintentar clasificación",
    failedTransactionsBanner: "{{count}} transacción(es) con clasificación fallida",
    retrySuccess: "Reintento iniciado",
    retryError: "No se pudo iniciar el reintento",
    errorTimedOut: "La clasificación de IA superó el tiempo de espera — vuelve a intentarlo o clasifica manualmente",
    errorRateLimited: "Se alcanzó el límite de solicitudes del proveedor de IA — vuelve a intentarlo en breve",
    errorGeneric: "La clasificación de IA falló — vuelve a intentarlo o clasifica manualmente",
    // Smart Import hold-back reasons (#142)
    holdBack: {
      missingFields: "Falta {{fields}}",
      fieldTicker: "ticker",
      fieldQuantity: "cantidad",
      fieldPrice: "precio",
      missingAccount: "Falta la cuenta",
      duplicate: "Duplicado",
      updateFailed: "Error al actualizar",
      commitError: "Error al confirmar",
      filterLabel: "Solo retenidas",
    },
    commitToast: {
      committedTitle: "Importación confirmada",
      partialTitle: "Confirmación parcial completada",
      created: "{{count}} creadas",
      updated: "{{count}} actualizadas",
      noneCommitted: "No se confirmó ninguna fila",
      heldBack: "{{count}} retenidas: {{reasons}}",
      missingTicker_one: "{{count}} sin ticker",
      missingTicker_other: "{{count}} sin ticker",
      missingQuantity_one: "{{count}} sin cantidad",
      missingQuantity_other: "{{count}} sin cantidad",
      missingPrice_one: "{{count}} sin precio",
      missingPrice_other: "{{count}} sin precio",
      missingAccount_one: "{{count}} sin cuenta",
      missingAccount_other: "{{count}} sin cuenta",
      duplicate_one: "{{count}} duplicada",
      duplicate_other: "{{count}} duplicadas",
      updateFailed_one: "{{count}} actualización fallida",
      updateFailed_other: "{{count}} actualizaciones fallidas",
      commitError_one: "{{count}} error al confirmar",
      commitError_other: "{{count}} errores al confirmar",
      stillToReview: "{{count}} pendientes de revisar",
      done: "Listo.",
    },
  },

  currencyRates: {
    title: "Tipos de cambio",
    subtitle: "Gestiona los tipos de cambio para cálculos financieros",
    refreshRates: "Actualizar tasas",
    addRate: "Añadir tasa",
    searchPlaceholder: "Buscar monedas o proveedores...",
    from: "Desde",
    to: "Hasta",
    rate: "Tasa",
    year: "Año",
    month: "Mes",
    day: "Día",
    provider: "Proveedor",
    lastUpdated: "Última actualización",
    noRatesFound: "No se encontraron tasas",
    addTitle: "Añadir tipo de cambio",
    providerOptional: "Proveedor (opcional)",
    adding: "Añadiendo...",
  },

  userManagement: {
    title: "Gestión de usuarios",
    subtitle: "Gestiona los usuarios y su acceso a tu tenant",
    createUser: "Crear usuario",
    createTitle: "Crear un nuevo usuario",
    createDescription: "Crea una nueva cuenta de usuario con credenciales de acceso.",
    editTitle: "Editar usuario",
    editDescription: "Actualiza la información y permisos de acceso del usuario",
    name: "Nombre",
    namePlaceholder: "Introduce su nombre",
    emailAddress: "Dirección de correo",
    emailPlaceholder: "Introduce su correo electrónico",
    password: "Contraseña",
    passwordPlaceholder: "Establece una contraseña (mín. 6 caracteres)",
    role: "Rol",
    selectRole: "Seleccionar rol",
    roleAdmin: "Administrador",
    roleMember: "Miembro",
    roleViewer: "Lector (solo lectura)",
    preferredLanguage: "Idioma preferido",
    selectLanguage: "Seleccionar idioma",
    birthDate: "Fecha de nacimiento",
    cancel: "Cancelar",
    updateUser: "Actualizar usuario",
    tenantUsers: "Usuarios del tenant",
    tenantUsersDescription: "Gestiona los usuarios con acceso a tus datos financieros",
    searchUsers: "Buscar usuarios...",
    statusFilter: "Estado",
    allStatuses: "Todos los estados",
    statusActive: "Activo",
    statusPending: "Pendiente",
    statusInactive: "Inactivo",
    showing: "Mostrando",
    of: "de",
    users: "usuarios",
    user: "Usuario",
    lastLogin: "Último acceso",
    never: "Nunca",
    editUser: "Editar usuario",
    resendInvitation: "Reenviar invitación",
    removeUser: "Eliminar usuario",
    noUsersFound: "No se encontraron usuarios con los filtros aplicados",
    userCreated: "Usuario creado",
    userCreatedDetail: "{{name}} ha sido creado correctamente",
    userCreateFailed: "Algo salió mal al crear el usuario",
    userUpdated: "Usuario actualizado",
    userUpdatedDetail: "{{name}} ha sido actualizado correctamente",
    userUpdateFailed: "Algo salió mal al actualizar el usuario",
    userRemoved: "Usuario eliminado",
    userRemovedDetail: "El usuario ha sido eliminado de este tenant",
    userRemoveFailed: "Algo salió mal al eliminar el usuario",
    invitationSent: "Invitación enviada",
    invitationSentDetail: "Se ha enviado una nueva invitación a {{email}}",
    invitationFailed: "Algo salió mal al reenviar la invitación",
    relationSelf: "Yo",
    relationPartner: "Pareja",
    relationChild: "Hijo/a",
    relationRelative: "Otro familiar",
    relationFriend: "Amigo/a",
    relationColleague: "Colega",
    relationOther: "Otro",
  },

  equityAnalysis: {
    diversified: "Diversificado",
    etfBadge: "ETF",
    basedOn: "basado en el {{pct}}% del valor",
    unmapped: "{{pct}}% sin identificar",
    copyBadge: "Copia",
    viaCopy: "vía @{{username}}",
    viaCopyIncluded: "incl. {{value}} vía @{{username}}",
    copyCash: "Efectivo",
    copyUnmapped: "Sin identificar",
    copySplit: "{{value}} repartido en {{count}} posiciones",
    title: "Análisis de acciones",
    subtitle: "Analiza tus inversiones por sector, industria, país y clase de activo",
    totalEquityValue: "Valor total de acciones",
    holdings: "Posiciones",
    avgPE: "P/E promedio",
    avgDividendYield: "Rendimiento por dividendo prom.",
    groupBy: "Agrupar por:",
    sector: "Sector",
    industry: "Industria",
    country: "País",
    allocationBy: "Asignación por {{grouping}}",
    noStockHoldings: "No se encontraron posiciones de acciones ni ETF",
    top10: "Top 10 posiciones por peso",
    allHoldings: "Todas las posiciones de acciones y ETF",
    noHoldingsHint: "No se encontraron posiciones. Añade acciones o ETF a tu portafolio para ver el análisis.",
    symbol: "Símbolo",
    name: "Nombre",
    pe: "P/E",
    divYield: "Rend. div.",
    eps: "BPA",
    weekRange: "Rango 52S",
    weight: "Peso",
    value: "Valor",
    loadFailed: "Error al cargar los datos de análisis de acciones.",
    assetClass: "Clase de activo",
    lookThrough: "Desglosar ETFs",
    lookThroughHint: "Reparte cada ETF entre los sectores y países que contiene",
    lookThroughWithCopies: "Desglosar ETFs y copias",
    lookThroughHintWithCopies: "Reparte cada ETF entre los sectores y países que contiene, y muestra cada copia de eToro como las posiciones en las que invierte",
    pendingSecurityData: "Esperando los datos del valor de {{symbols}}. Estos fondos aparecerán aquí cuando se obtengan.",
    lookThroughOther: "Otros",
    fixedIncomeBucket: "Renta fija",
    editAssetClass: "Editar la clase de activo de {{symbol}}",
    automatic: "Automática ({{assetClass}})",
    overrideSaved: "Clase de activo actualizada",
    overrideFailed: "No se pudo actualizar la clase de activo",
    overrideHint: "Definida manualmente",
    etfBreakdown: "Principales sectores",
    save: "Guardar",
    cancel: "Cancelar",
    assetClasses: {
      STOCK: "Acción",
      INDEX_ETF: "ETF indexado",
      SECTOR_ETF: "ETF sectorial",
      BOND_ETF: "ETF de bonos",
      REIT: "REIT",
      FUND: "Fondo",
      GOV_BOND: "Bono público",
      CORP_BOND: "Bono corporativo",
      REAL_ESTATE: "Inmueble",
      CRYPTO: "Cripto",
      CASH: "Efectivo",
      OTHER: "Otro",
      COPY_TRADE: "Copy trading",
    },
  },

  notFoundPage: {
    code: "404",
    message: "¡Ups! Página no encontrada.",
    returnHome: "Volver al inicio",
  },

  plaidConnect: {
    success: "Éxito",
    bankReauthenticated: "La conexión bancaria se ha reautenticado correctamente.",
    reauthFailed: "La reautenticación fue exitosa pero no se pudo actualizar el estado.",
    exchangeFailed: "Error en el intercambio",
    connectFailed: "Error al conectar la cuenta bancaria.",
    reconnect: "Reconectar",
    connectBank: "Conectar banco",
  },

  accountSelection: {
    loadFailed: "Error al cargar las cuentas del banco.",
    allAccountTypes: "Todos los tipos de cuenta",
    createNew: "Crear nueva",
    createNewAccount: "Crear cuenta nueva",
    linkToExisting: "Vincular a existente",
    selectOrCreate: "Seleccionar o crear",
    accountNames: "Nombres de cuentas",
    accountMappings: "Mapeo de cuentas",
    unsupportedCurrencies: "Monedas no soportadas",
    unsupportedCountry: "País no soportado",
    seedInterview: "Entrevista de inicialización",
    allCategories: "Todas las categorías",
    fetchFailed: "Error al obtener las cuentas de Plaid",
    setupTitle: "Configurar Cuentas",
    syncingTitle: "Sincronización en Progreso...",
    quickClassify: "Clasificación Rápida",
    syncComplete: "Sincronización Completada",
    setupDescription: "Elige las cuentas a sincronizar, vincúlalas a existentes y establece nombres.",
    syncingDescription: "Tus transacciones se están sincronizando y clasificando por IA.",
    seedDescription: "Encontramos tus transacciones más recurrentes. Confirma o ajusta sus categorías para mejorar la IA en tu próxima sincronización.",
    doneDescription: "Todas las transacciones han sido sincronizadas y clasificadas.",
    newCurrenciesDetected: "Nuevas monedas detectadas",
    currenciesUse: "Estas cuentas usan",
    currenciesNotConfigured: "que {{plurality}} aún no están en tu espacio de trabajo. Se agregarán automáticamente al sincronizar.",
    newCountryDetected: "Nuevo país detectado",
    bankOperatesIn: "Este banco opera en",
    countryNotConfigured: "que aún no está en tu espacio de trabajo. Se agregará automáticamente al sincronizar.",
    notConfigured: "no configurado",
    accountNamePlaceholder: "Nombre de cuenta",
    existingAccountKept: "Se mantendrá el nombre de la cuenta existente",
    noAccountsFound: "No se encontraron cuentas.",
    syncHistoryNote: "Bliss sincronizará hasta 2 años de historial. Las transacciones recientes aparecen en segundos; el historial completo llega en 24 horas.",
    syncAccounts: "Sincronizar {{count}} Cuentas",
    accountsLinked: "Cuentas vinculadas",
    syncingTransactions: "Sincronizando transacciones",
    aiClassifying: "IA clasificando",
    importingTransactions: "Importando tus transacciones recientes",
    importingFrom: "desde",
    fullHistoryNote: "Tu historial completo de 2 años continuará sincronizándose en segundo plano.",
    promoted: "Promovidas",
    pendingReview: "Pendientes de Revisión",
    processing: "Procesando",
    doNotClose: "Por favor, no cierres este diálogo mientras la sincronización está en curso.",
    skipForNow: "Omitir por ahora",
    confirmContinue: "Confirmar y Continuar",
    seedSaveFailed: "No se pudieron guardar las selecciones de categoría.",
    historyRange: "Rango de Historial",
    readyForReview: "Listas para Revisión",
    skippedDuplicates: "Omitidas (duplicados)",
    fullHistorySyncing: "Historial completo sincronizándose en segundo plano",
    currentlySyncedFrom: "Actualmente sincronizado desde",
    fullHistoryDetail: "Bliss sincronizará automáticamente hasta 2 años de historial de transacciones en las próximas 24 horas. Las nuevas transacciones aparecerán en tu cola de revisión a medida que lleguen — no se requiere acción.",
    reviewTransactions: "Revisar Transacciones",
    linkFailed: "Error al vincular cuentas.",
  },

  changePassword: {
    title: "Cambiar contraseña",
    description: "Introduce tu contraseña actual y elige una nueva.",
    currentPassword: "Contraseña actual",
    currentPasswordRequired: "La contraseña actual es obligatoria",
    newPassword: "Nueva contraseña",
    newPasswordMin: "La contraseña debe tener al menos 8 caracteres",
    minHint: "Mínimo 8 caracteres",
    confirmPassword: "Confirmar nueva contraseña",
    confirmRequired: "Por favor, confirma tu nueva contraseña",
    mismatch: "Las contraseñas no coinciden",
    updatePassword: "Actualizar contraseña",
    passwordUpdated: "Contraseña actualizada",
    passwordUpdatedDetail: "Tu contraseña ha sido cambiada correctamente.",
    changeFailed: "Error al cambiar la contraseña",
  },

  transactionFormPage: {
    pickDate: "Seleccionar fecha",
    descriptionPlaceholder: "ej. Supermercado, Salario, Alquiler",
    selectAccount: "Por favor, selecciona una cuenta",
    selectCurrency: "Por favor, selecciona una moneda",
    selectCategory: "Por favor, selecciona una categoría",
    pricePerShare: "Precio por acción",
    pricePlaceholder: "ej. 43.67",
    quantity: "Cantidad",
    quantityAuto: "(auto)",
    quantityCalculated: "Calculado automáticamente",
    quantityPlaceholder: "ej. 1.23",
    detailsNotes: "Detalles / Notas",
    notesPlaceholder: "Notas opcionales (reemplaza la descripción predeterminada)",
    debtTerms: "Términos de deuda",
    initialBalance: "Saldo inicial",
    interestRate: "Tasa de interés (%)",
    termMonths: "Plazo (en meses)",
    originationDate: "Fecha de origen",
    tags: "Etiquetas",
    saving: "Guardando...",
    updatedSuccess: "Transacción actualizada correctamente.",
    createdSuccess: "Transacción creada correctamente.",
    saveFailed: "Error al guardar la transacción. Inténtalo de nuevo.",
    currencyMismatch: "Este activo cotiza en {{currency}}. Selecciona una cuenta en {{currency}}.",
    currencyMismatchAlt: "Selecciona una cuenta en {{currency}} o elige un activo que cotice en {{txCurrency}}.",
    tickerRequired: "El ticker es obligatorio para esta categoría.",
    priceRequired: "El precio es obligatorio para esta categoría.",
    quantityRequired: "La cantidad es obligatoria para esta categoría.",
    dateLabel: "Fecha",
    descriptionLabel: "Descripción",
    accountLabel: "Cuenta",
    creditLabel: "Crédito",
    debitLabel: "Débito",
    categoryLabel: "Categoría",
    investmentDetails: "Detalles de inversión",
    investmentDetailsHint: "(selecciona una categoría de inversión para habilitar)",
    tickerLabel: "Ticker",
    tickerPlaceholder: "ej., AAPL, VWCE",
    etoroUsernameLabel: "Usuario de eToro",
    etoroUsernamePlaceholder: "Inversor copiado, p. ej. topinvestor",
    copyTradeAmountHint: "Indica el importe que pusiste en la copia (o retiraste). No hay precio ni cantidad: el importe es tu coste y eToro aporta el valor.",
    loadingFormData: "Cargando datos del formulario...",
    closePosition: "Cerrar posición completa",
    closePositionHint: "Establece la cantidad a tu posición exacta de {{quantity}} unidades",
    closePositionActive: "Cierre de posición activo",
    lotMismatchWarning: "Desajuste de cantidad en posición",
    lotMismatchDetail: "Esta posición muestra cantidad negativa — puede faltar una compra o una transferencia entre cuentas no registrada.",
  },

  debtTermsForm: {
    initialBalance: "Saldo inicial",
    initialBalanceError: "El saldo inicial debe ser un número positivo.",
    interestRate: "Tasa de interés (%)",
    interestRateNegative: "La tasa de interés no puede ser negativa.",
    interestRateTooHigh: "La tasa de interés parece demasiado alta.",
    termMonths: "Plazo (en meses)",
    termError: "El plazo debe ser un número positivo de meses.",
    originationDate: "Fecha de origen",
    originationRequired: "Se requiere una fecha de origen.",
    pickDate: "Seleccionar fecha",
    saveTerms: "Guardar términos",
    saving: "Guardando...",
    success: "¡Éxito!",
    savedDetail: "Los términos de deuda de {{name}} han sido guardados.",
    saveFailed: "Error al guardar los términos. Inténtalo de nuevo.",
  },

  manualPriceForm: {
    date: "Fecha",
    pickDate: "Seleccionar fecha",
    price: "Precio",
    pricePlaceholder: "ej. 150.50",
    currency: "Moneda",
    currencyPlaceholder: "ej. USD",
    notes: "Notas (opcional)",
    notesPlaceholder: "ej. Fuente de valoración",
    savePrice: "Guardar precio",
    saving: "Guardando...",
    success: "¡Éxito!",
    savedDetail: "El precio de {{name}} ha sido actualizado.",
    saveFailed: "Error al actualizar el precio. Inténtalo de nuevo.",
  },

  manualPriceHistory: {
    title: "Historial de precios — {{symbol}}",
    dialogDescription: "Revisa, edita o elimina los precios que has registrado manualmente para este activo.",
    addTitle: "Registrar un precio — {{symbol}}",
    editTitle: "Editar precio — {{symbol}}",
    countLabel_one: "{{count}} actualización",
    countLabel_other: "{{count}} actualizaciones",
    countLabel: "{{count}} actualizaciones",
    effectiveDate: "Fecha efectiva",
    price: "Precio",
    currency: "Moneda",
    notes: "Notas",
    recordedOn: "Registrado el",
    actions: "Acciones",
    edit: "Editar",
    delete: "Eliminar",
    back: "Volver al historial",
    differentCurrency: "Esta entrada está registrada en una moneda distinta a la del activo.",
    emptyTitle: "Aún no se han registrado precios manuales",
    emptyBody: "Registra el primer precio de este activo para empezar a construir su historial.",
    recordFirst: "Registrar primer precio",
    recordPrice: "Registrar precio",
    loadError: "Error al cargar el historial de precios.",
    retry: "Reintentar",
    deleteConfirmTitle: "¿Eliminar esta entrada de precio?",
    deleteConfirmBody: "Esto elimina permanentemente el precio registrado y vuelve a activar la valoración de la cartera. Esta acción no se puede deshacer.",
    deleted: "Entrada de precio eliminada",
    deleteFailed: "Error al eliminar la entrada de precio. Inténtalo de nuevo.",
    viewHistory: "Ver historial",
    lastUpdated: "Última actualización",
    allManualAssetsTitle: "Todos los activos con precio manual",
    allManualAssetsDesc: "Todos los activos que valoras manualmente. Abre su historial para revisar, editar o eliminar entradas anteriores.",
    noManualAssets: "Aún no hay activos con precio manual.",
    pagination: "Mostrando {{from}}–{{to}} de {{total}}",
    prev: "Anterior",
    next: "Siguiente",
  },

  categoryCombobox: {
    search: "Buscar categorías...",
    noResults: "No se encontraron categorías.",
  },

  categoryFormPage: {
    nameMin: "El nombre debe tener al menos 2 caracteres",
    typeRequired: "El tipo es obligatorio",
    groupRequired: "El grupo es obligatorio",
    iconLabel: "Icono",
    iconHint: "Pega cualquier emoji para usarlo como icono de la categoría.",
    recurringLabel: "Cargo recurrente",
    recurringHint: "Muestra las transacciones de esta categoría en la vista de Suscripciones. Basta con un solo cargo para incluirla.",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Explica brevemente cuándo usar esta categoría…",
    descriptionHint: "Se muestra como tooltip en el selector de categorías. Te ayuda a ti (o a otros en tu cuenta) a elegir la categoría correcta.",
    namePlaceholder: "ej. Supermercado, Salario, Alquiler",
    selectType: "Seleccionar tipo",
    selectGroup: "Seleccionar grupo",
    selectTypeFirst: "Selecciona un tipo primero",
    createNewGroup: "+ Crear nuevo grupo\u2026",
    enterNewGroup: "Introduce el nombre del nuevo grupo",
    iconOptional: "(opcional)",
  },

  categoriesPage: {
    defaultBadge: "Predeterminada",
    systemHint: "Categoría del sistema — usada para la clasificación IA en todos los tenants. No se puede eliminar.",
    transaction: "transacción",
    transactions: "transacciones",
    categoryOptions: "Opciones de categoría",
    rename: "Renombrar",
    addTo: "Añadir a {{type}}",
    reassignAndDelete: "Reasignar y eliminar",
    reassignMessage: "\"{{name}}\" tiene {{count}} transacción(es). Elige una categoría para reasignarlas antes de eliminar.",
    selectTargetCategory: "Seleccionar categoría destino",
    deleteAndReassign: "Eliminar y reasignar",
    deletedAndReassigned: "{{name}} eliminada y {{count}} transacción(es) reasignadas",
  },

  expenseSplit: {
    title: "Desglose de gastos",
    thisYear: "Este año",
    thisMonth: "Este mes",
    lastMonth: "Mes pasado",
    last3Months: "Últimos 3 meses",
    noData: "No hay datos de gasto para este período.",
    viewExpenses: "Ver gastos",
    ofSpending: "del gasto",
    basis: "Débitos − créditos",
    netCredits: "Créditos netos",
    noNetSpend: "Sin gasto neto en este período",
  },

  // Smart Import page
  smartImport: {
    title: "Importar",
    subtitle: "Sube un archivo CSV o Excel, deja que la IA clasifique tus transacciones, luego revisa y confirma.",
    cancelImport: "Cancelar importación",
    steps: {
      upload: "Subir",
      processing: "Procesando",
      review: "Revisar",
      done: "Listo",
    },
    status: {
      confirmed: "Confirmado",
      pending: "Pendiente",
      duplicate: "Duplicado",
      possibleDup: "Posible dup.",
      skipped: "Omitido",
      error: "Error",
    },
    source: {
      manual: "Manual",
      exact: "Exacto",
      vector: "Vector",
      ai: "IA",
    },
    selectFile: "Seleccionar archivo",
    selectFileDesc: "Elige un extracto bancario o archivo de exportación (CSV o Excel) para importar.",
    dropzone: "Haz clic para seleccionar o arrastra un archivo CSV o Excel",
    detectingFormat: "Detectando formato del archivo...",
    formatDetected: "Formato detectado: {{name}}",
    formatDetectedDesc: "Este archivo coincide con el adaptador {{name}}. El mapeo de columnas se aplicará automáticamente.",
    unknownFormat: "Formato desconocido",
    unknownFormatDesc: "Ningún adaptador coincide con este archivo. Encabezados detectados:",
    unknownFormatHeaderHint: "Bliss lee los encabezados de columna en la primera fila del archivo (o de la hoja, en Excel). Si el archivo tiene líneas por encima de los encabezados —nombre de cuenta, periodo, saldo—, elimínalas y vuelve a subirlo.",
    createAdapterForFormat: "Crear adaptador para este formato",
    destinationAccount: "Cuenta de destino",
    destinationAccountDesc: "Todas las transacciones se importarán a esta cuenta.",
    destinationAccountNative: "Opcional — el adaptador nativo resuelve la cuenta por fila desde tu CSV.",
    selectAccount: "Seleccionar una cuenta...",
    optionalFromCsv: "Opcional — resuelto desde CSV...",
    nativeAccountHint: "La columna de cuenta de cada fila sobreescribe esta selección. Solo selecciona un respaldo aquí si algunas filas no tienen cuenta especificada.",
    uploading: "Subiendo...",
    uploadAndProcess: "Subir y procesar",
    importAdapters: "Adaptadores de importación",
    hide: "Ocultar",
    manage: "Gestionar",
    noAdapters: "Sin adaptadores aún. Crea uno para comenzar a importar.",
    newAdapter: "Nuevo adaptador",
    system: "Sistema",
    template: "Plantilla",
    editAdapter: "Editar adaptador",
    createAdapter: "Crear adaptador",
    adapterFormDesc: "Define cómo las columnas de tu CSV/Excel bancario se mapean a los campos de transacción de Bliss.",
    form: {
      name: "Nombre",
      nameRequired: "El nombre del adaptador es obligatorio",
      namePlaceholder: "CSV Cuenta Chase",
      matchHeaders: "Encabezados de coincidencia",
      matchHeadersPlaceholder: "Fecha, Descripción, Monto",
      matchHeadersHint: "Encabezados de columna que identifican de forma única el formato de exportación de tu banco.",
      matchHeadersChipsHint: "Selecciona los encabezados de tu archivo que identifican este formato. Añade uno personalizado si no aparece.",
      addCustomHeader: "Añadir encabezado personalizado",
      dateColumn: "Columna de fecha",
      dateColumnPlaceholder: "Fecha",
      descriptionColumn: "Columna de descripción",
      descriptionColumnPlaceholder: "Descripción",
      amountStrategy: "Distribución de importe",
      singleSigned: "Una columna, con signo (mayoría de bancos)",
      singleSignedDesc: "Ej. -45.20 = gasto, 25.00 = ingreso",
      singleSignedInverted: "Una columna, signos invertidos (p.ej. Amex)",
      singleSignedInvertedDesc: "Ej. 45.20 = gasto, -25.00 = devolución",
      debitCredit: "Columnas de débito y crédito separadas",
      debitCreditDesc: "Dos columnas separadas para cargos y abonos",
      amountWithType: "Importe + columna de tipo",
      amountWithTypeDesc: "Una columna de importe y otra que indica la dirección",
      typeColumn: "Columna de tipo",
      typeColumnPlaceholder: "Tipo",
      categoryColumn: "Columna de categoría (opcional)",
      categoryColumnPlaceholder: "Ninguna — omitir sugerencia de categoría",
      categoryColumnHint: "Si tu archivo tiene columna de categoría, mapearla mejora la precisión de la IA",
      debitColumn: "Columna de débito",
      debitColumnPlaceholder: "Débito",
      creditColumn: "Columna de crédito",
      creditColumnPlaceholder: "Crédito",
      amountColumn: "Columna de monto",
      amountColumnPlaceholder: "Monto",
      customColumn: "Columna personalizada…",
      dateFormat: "Formato de fecha",
      dateFormatAuto: "Detección automática (recomendado)",
      dateFormatCustom: "Formato personalizado…",
      dateFormatGroupDate: "Solo fecha",
      dateFormatGroupDateTime: "Fecha + Hora",
      dateFormatAmbiguousWarning: "Formato de fecha ambiguo (todos los valores ≤ 12). Selecciona un formato explícito para evitar errores MM/DD vs DD/MM.",
      dateFormatHint: "Elige un formato o selecciona Personalizado",
      defaultCurrency: "Moneda predeterminada",
      currencyHint: "Deja en blanco si tu CSV tiene columna de moneda por fila",
      currencyNone: "Ninguna — usar columna de moneda por fila",
      skipRows: "Filas a omitir (filas de encabezado)",
      previewTitle: "Vista previa fila 1",
      previewHint: "Completa las columnas de arriba para ver cómo se leerá la fila 1",
      previewNoData: "Sube un archivo primero para activar la vista previa",
      previewDate: "Fecha",
      previewDescription: "Descripción",
      previewAmount: "Importe",
      previewCurrency: "Moneda",
      previewBankCategory: "Categoría del banco",
    },
    unknownFormatSamplePreview: "Filas de muestra de tu archivo:",
    processingTitle: "Procesando tu importación",
    processingDesc: "La IA está clasificando tus transacciones. Esto puede tardar un momento...",
    percentComplete: "{{pct}}% completado",
    unknownAccount: "Cuenta desconocida",
    quickClassify: "Clasificación rápida",
    quickClassifyDesc: "Encontramos tus transacciones más recurrentes. Confirma o ajusta sus categorías para mejorar la IA en futuras importaciones.",
    skipForNow: "Omitir por ahora",
    confirmAndContinue: "Confirmar y continuar",
    confirmAll: "Confirmar todo",
    seed: {
      global: "Global",
      match: "Coincidencia",
      restore: "Restaurar",
      skipMerchant: "Omitir este comerciante",
    },
    review: {
      file: "Archivo",
      account: "Cuenta",
      total: "Total",
      nRows: "{{count}} filas",
      earliest: "Más antigua",
      autoConfirmed: "{{count}} auto-confirmadas",
      nUpdates: "{{count}} actualizaciones",
      pendingReview: "{{count}} pendientes de revisión",
      nDuplicates: "{{count}} duplicados",
      nErrors: "{{count}} errores",
      filterByStatus: "Filtrar por estado",
      flat: "Plano",
      grouped: "Agrupado",
      errorLoadingTitle: "Error al cargar importación",
      errorLoadingDesc: "No se pudieron cargar los datos de la importación. Intenta actualizar la página.",
      noRowsFound: "No se encontraron filas",
      tryDifferentFilter: "Prueba un filtro diferente.",
      noRowsProduced: "La importación no produjo ninguna fila.",
      pageOf: "Página {{current}} de {{total}}",
    },
    filter: {
      allRows: "Todas las filas",
      possibleDuplicate: "Posible duplicado",
    },
    committingTitle: "Confirmando transacciones",
    committingDesc: "Creando transacciones a partir de tus filas confirmadas...",
    committing: "Confirmando...",
    commitImport: "Confirmar aprobadas",
    importError: "Error de importación",
    processingError: "Ocurrió un error durante el procesamiento.",
    processingFailed: "Procesamiento fallido",
    startOver: "Comenzar de nuevo",
    importComplete: "¡Importación completa!",
    importCompleteDesc: "Tus transacciones se han confirmado exitosamente.",
    done: {
      created: "Creadas",
      updated: "Actualizadas",
      remaining: "Restantes",
    },
    importAnotherFile: "Importar otro archivo",
    reviewInTransactionReview: "Revisar en Revisión de Transacciones",
    commitDialogDesc: "Esto creará transacciones solo para las filas confirmadas. Las filas pendientes permanecerán disponibles para revisión futura. Esta acción no se puede deshacer.",
    goBack: "Volver",
    yesCommit: "Sí, confirmar",
    cancelDialogDesc: "¿Estás seguro de que quieres cancelar? Todas las filas preparadas se descartarán.",
    cancelling: "Cancelando...",
    yesCancelImport: "Sí, cancelar importación",
    toast: {
      importReady: "Importación lista",
      rowsReady: "{{count}} filas listas para revisión.",
      seedSaveFailed: "No se pudieron guardar las selecciones de categoría.",
      detectionFailed: "Detección fallida",
      detectionFailedDesc: "No se pudo detectar el formato del archivo. Verifica tu archivo CSV o Excel.",
      uploadFailed: "Subida fallida",
      uploadFailedDesc: "No se pudo iniciar la importación. Inténtalo de nuevo.",
      otherTransactions: "{{count}} otras transacciones en \"{{category}}\"",
      confirmAllQuestion: "¿Confirmar todas?",
      confirmedN: "{{count}} transacciones confirmadas",
      commitStarted: "Confirmación iniciada",
      commitStartedDesc: "Tus transacciones se están confirmando...",
      commitFailed: "Confirmación fallida",
      commitFailedDesc: "No se pudo iniciar el proceso de confirmación.",
      importCancelled: "Importación cancelada",
      cancelFailed: "Cancelación fallida",
      adapterUpdated: "Adaptador actualizado",
      adapterCreated: "Adaptador creado",
      adapterDeleted: "Adaptador eliminado",
      formatMatched: "Formato coincidente: {{name}}",
      formatMatchedDesc: "Tu archivo ahora es reconocido. Puedes proceder con la subida.",
      updateFailed: "Actualización fallida",
      createFailed: "Creación fallida",
      deleteFailed: "Eliminación fallida",
    },
  },

  // Insights page
  insights: {
    title: "Análisis",
    subtitle: "Observaciones financieras impulsadas por IA",
    v1Subtitle: "Inteligencia financiera impulsada por IA: revisiones mensuales, tendencias trimestrales, resúmenes anuales y análisis de cartera",
    lastUpdated: "Última actualización",
    generating: "Generando...",
    generateNew: "Generar nuevos análisis",
    generate: "Generar análisis",
    generateAll: "Generar todos los niveles",
    refresh: "Actualizar",
    refreshTier: "Regenerar",
    moreActions: "Más acciones",
    reload: "Recargar",
    clearFilters: "Quitar filtros",
    noInsightsYet: "Sin análisis aún",
    noInsightsDesc: "Una vez que tengas datos de transacciones, Bliss analizará tus finanzas y destacará patrones importantes.",
    noCategoryInsights: "No hay análisis que coincidan con las categorías seleccionadas para este período.",
    noTierInsightsDesc: "Aún no se ha generado ningún análisis para este nivel. Pulsa Regenerar para crear uno para el período más reciente.",
    period: {
      selectPlaceholder: "Seleccionar período",
      q: "T",
    },
    severity: {
      POSITIVE: "Positivo",
      INFO: "Info",
      WARNING: "Advertencia",
      CRITICAL: "Crítico",
    },
    categories: {
      all: "Todos",
      spending: "Gastos",
      income: "Ingresos",
      savings: "Ahorros",
      portfolio: "Cartera",
      debt: "Deuda",
      netWorth: "Patrimonio neto",
    },
    tiers: {
      monthly: "Revisión mensual",
      quarterly: "Análisis trimestral",
      annual: "Informe anual",
      portfolio: "Inteligencia de cartera",
    },
    lens: {
      passiveIncomeOutlook: "Perspectiva de ingresos pasivos",
    },
    actions: {
      passiveIncomeSetup: "Configurar condiciones de ingresos",
      portfolioHoldings: "Cartera de inversiones",
    },
  },

  // Manual Updates page
  manualUpdates: {
    pageTitle: "Actualizaciones manuales y términos",
    pageSubtitle: "Mantén tus activos manuales y pasivos actualizados.",
    errorLoading: "Error al cargar los datos de activos. Inténtalo de nuevo más tarde.",
    stalePricesTitle: "Acción requerida: Precios desactualizados",
    stalePricesDesc: "Estos activos de seguimiento manual no se han actualizado en más de 30 días.",
    asset: "Activo",
    value: "Valor",
    status: "Estado",
    action: "Acción",
    never: "Nunca",
    updatedOn: "Actualizado {{date}}",
    dOld: "{{count}}d antiguo",
    updatePrice: "Actualizar precio",
    allUpToDate: "Todos los activos de seguimiento manual están actualizados.",
    liabilityTerms: "Términos de pasivos",
    liabilityTermsDesc: "Gestiona los términos de tus préstamos y líneas de crédito de seguimiento manual.",
    debtName: "Nombre de deuda",
    principalBalance: "Saldo principal",
    interestRate: "Tasa de interés",
    duration: "Duración",
    yr: "año",
    mo: "mes",
    editTerms: "Editar términos",
    addTerms: "Agregar términos",
    totalOutstanding: "Total pendiente",
    noLiabilities: "No se encontraron pasivos.",
    updatePriceDialog: "Actualizar precio",
    debtTermsDialog: "Términos de deuda",
    urgency: {
      critical: "Crítico",
      warning: "Advertencia",
      stale: "Desactualizado",
    },
  },

  spendingChart: {
    title: "Gasto por categoría",
    selectPeriod: "Seleccionar período",
    thisMonth: "Este mes",
    lastMonth: "Mes pasado",
    last3Months: "Últimos 3 meses",
    noData: "No hay datos de gasto para este período.",
  },

  // Portfolio holdings page
  portfolio: {
    title: "Cartera de inversiones",
    subtitle: "Rastrea el rendimiento y la asignación de tu cartera de inversiones",
    assets: "Activos",
    liabilities: "Pasivos",
    positionCount_one: "{{count}} posición",
    positionCount_other: "{{count}} posiciones",
    positionCount: "{{count}} posiciones",
    symbol: "Símbolo",
    qty: "Cant.",
    price: "Precio",
    costBasis: "Coste base",
    unrealizedPnL: "P&L no realizado",
    realizedPnL: "P&L realizado",
    roiPercent: "ROI %",
    totalValue: "Valor total",
    roiTooltip: "ROI total = (P&L realizado + no realizado) / Total invertido",
    showDebt: "Mostrar deuda",
    allAccounts: "Todas las cuentas",
    allCountries: "Todos los países",
    noHistoricalData: "No hay datos históricos disponibles para este período.",
    // Holding filter (#131)
    allHoldings: "Todas las posiciones",
    searchHoldings: "Buscar posiciones…",
    noHoldingsFound: "No se encontraron posiciones.",
    showClosedPositionsToggle: "Mostrar posiciones cerradas",
    closedBadge: "Cerrada",
    closedPositionsGroup: "Posiciones cerradas",
    clearHolding: "Quitar filtro de posición",
    showInChart: "Ver en el gráfico",
    holdingNotInAccount: "{{symbol}} no está en {{account}}",
    noHistoryForHolding: "Sin historial de {{name}} en este período",
    holdingPickerLabel: "Filtrar el gráfico por posición",
    netWorth: "Patrimonio neto",
    emptyState: "Aún no hay datos de cartera. Conecta una cuenta bancaria o importa transacciones para comenzar.",
    connectAccount: "Conectar cuenta",
    importCSV: "Importar CSV",
    errorTitle: "Error al cargar la cartera",
    errorDescription: "Hubo un problema al obtener los datos de tu cartera. Inténtalo más tarde.",
    liability: "Pasivo",
    interestRate: "Tasa de interés",
    term: "Plazo",
    balance: "Saldo",
    totalOutstanding: "Total pendiente",
    editTerms: "Editar condiciones",
    addTerms: "Agregar condiciones",
    hideClosedPositions_one: "Ocultar {{count}} posición cerrada",
    hideClosedPositions_other: "Ocultar {{count}} posiciones cerradas",
    hideClosedPositions: "Ocultar {{count}} posiciones cerradas",
    showClosedPositions_one: "Mostrar {{count}} posición cerrada",
    showClosedPositions_other: "Mostrar {{count}} posiciones cerradas",
    showClosedPositions: "Mostrar {{count}} posiciones cerradas",
  },

  // Tag analytics page
  tagAnalytics: {
    title: "Análisis por etiquetas",
    subtitle: "Analiza gastos por etiqueta en todas las cuentas y monedas",
    selectTag: "Selecciona una etiqueta...",
    compare: "Comparar",
    compareWith: "Comparar con...",
    searchTags: "Buscar etiquetas...",
    noTagsFound: "No se encontraron etiquetas.",
    emptyTitle: "Selecciona una etiqueta para ver el análisis",
    emptyDescription: "Elige una etiqueta arriba para ver desgloses de gastos, tendencias y seguimiento de presupuesto",
    totalDebit: "Total débito",
    totalCredit: "Total crédito",
    balance: "Saldo",
    budgetProgress: "Progreso del presupuesto",
    topCategory: "Categoría principal",
    categoryBreakdown: "Desglose por categoría",
    noSpendingData: "No hay datos de gasto para esta etiqueta",
    cashFlowTimeline: "Línea de tiempo de flujo de caja",
    noTimelineData: "No hay datos de línea de tiempo",
    monthly: "Mensual",
  },

  // Auth page — flat string keys
  "Sign In": "Iniciar sesión",
  "Sign Up": "Registrarse",
  "Sign in with Google": "Iniciar sesión con Google",

  // Auth rejection messages (task #71 — identity hygiene)
  "An account with this email already exists. Sign in with your password instead.": "Ya existe una cuenta con este correo electrónico. Inicia sesión con tu contraseña.",
  "Your Google account's email address is not verified. Verify it with Google, then try again.": "La dirección de correo de tu cuenta de Google no está verificada. Verifícala con Google e inténtalo de nuevo.",
  "Sign-in with Google failed. Please try again.": "No se pudo iniciar sesión con Google. Inténtalo de nuevo.",
  "We could not sign you in automatically. Please try signing in with your password.": "No hemos podido iniciar tu sesión automáticamente. Prueba a iniciar sesión con tu contraseña.",

  // Invite-only sign-up (task #99)
  "This Bliss instance is invite-only. Use the email address you were invited with.": "Esta instancia de Bliss es solo por invitación. Usa la dirección de correo con la que te invitaron.",
  "This email hasn't been invited to this Bliss instance. Ask the person who runs it for an invite.": "Este correo electrónico no ha sido invitado a esta instancia de Bliss. Pide una invitación a la persona que la gestiona.",
  "Sign up with Google": "Registrarse con Google",
  "or continue with email": "o continúa con correo electrónico",
  "Email address": "Correo electrónico",
  "Password": "Contraseña",
  "Signing in...": "Iniciando sesión...",
  "Login failed": "Error al iniciar sesión",
  "Full name": "Nombre completo",
  "Use at least 8 characters, including a number.": "Usa al menos 8 caracteres, incluyendo un número.",
  "By creating an account you agree to our": "Al crear una cuenta aceptas nuestros",
  "and": "y",
  "Registration failed": "Error de registro",
  "Creating account...": "Creando cuenta...",
  "Create Account": "Crear cuenta",
  "Don't have an account?": "¿No tienes una cuenta?",
  "Create one": "Créala",
  "Already have an account?": "¿Ya tienes una cuenta?",
  "Sign in": "Inicia sesión",
  "Welcome to the Bliss demo. Use the credentials below to sign in and explore.": "Bienvenido a la demo de Bliss. Usa las credenciales a continuación para iniciar sesión y explorar.",
  "The quiet intelligence behind your global wealth.": "La inteligencia silenciosa detrás de tu patrimonio global.",
  "Financial clarity, without borders.": "Claridad financiera, sin fronteras.",
  "Bliss capybara in a turtleneck, seated in a mid-century chair beside a stack of currency coins": "Capibara de Bliss con cuello de tortuga, sentado en una silla de mediados de siglo junto a monedas",
  "Bliss capybara mascot seated in a mid-century chair": "Mascota capibara de Bliss sentada en una silla de mediados de siglo",
  "Welcome back": "Bienvenido de nuevo",
  "Protected by enterprise-grade encryption.": "Protegido con cifrado de nivel empresarial.",

  // Dashboard actions — flat string keys
  "Fix Bank Connection": "Reparar conexión bancaria",
  "A bank connection needs your attention": "Una conexión bancaria requiere tu atención",
  "Review Pending Transactions": "Revisar transacciones pendientes",
  "Check and categorize imported transactions": "Revisa y categoriza las transacciones importadas",
  "Update Asset Prices": "Actualizar precios de activos",
  "Some manual assets need a price refresh": "Algunos activos manuales necesitan actualización de precio",
  "Connect your bank": "Conecta tu banco",
  "Plaid (US, CA, UK) or Enable Banking (EU) for automatic sync": "Plaid (EE. UU., CA, R. U.) o Enable Banking (UE) para sincronización automática",
  "Add Manual Account": "Agregar cuenta manual",
  "Manually track an account or asset": "Rastrea manualmente una cuenta o activo",
  "Import Transactions": "Importar transacciones",
  "Upload a CSV file to import transactions": "Sube un archivo CSV para importar transacciones",
  "View Insights": "Ver perspectivas",
  "See AI-generated financial observations": "Ver observaciones financieras generadas por IA",
  "Explore Expenses": "Explorar gastos",
  "See how your spending breaks down": "Ve cómo se distribuyen tus gastos",
  "View Financial Summary": "Ver Resumen Financiero",
  "View income vs expenses over time": "Ver ingresos vs gastos a lo largo del tiempo",
  "View Accounts": "Ver cuentas",
  "See all your connected accounts": "Ver todas tus cuentas conectadas",

  // Setup checklist — flat string keys
  "Get started with Bliss": "Comienza con Bliss",
  "of": "de",
  "complete": "completado",
  "Dismiss": "Descartar",
  // ─── Subscriptions / recurring charges ───────────────────────────────────────
  subscriptions: {
    title: "Suscripciones",
    subtitle: "Cargos recurrentes detectados en tus cuentas.",
    scanNow: "Escanear ahora",
    scanCooldownShort: "Escanear en {{count}} min",
    scanStarted: "Escaneo iniciado",
    scanStartedHint: "La detección se ejecuta en segundo plano. Los resultados aparecerán pronto.",
    scanCooldown: "Escaneo en espera",
    scanCooldownHint: "Podrás volver a escanear en unos {{count}} minutos.",
    actionFailed: "La acción falló",
    fullScanHintPrefix: "Puede que falten suscripciones anuales antiguas —",
    fullScanHintLink: "ejecuta un escaneo de todo el historial",
    fullScanHintSuffix: " en Ajustes → Mantenimiento.",
    loadError: "No se pudieron cargar las suscripciones.",
    uncategorized: "Sin categoría",
    toggleCharges: "Mostrar cargos individuales",
    noCharges: "No se encontraron cargos para este comercio.",
    fxUnavailable: "Sin tipo de cambio",
    occurrences_one: "{{count}} cargo",
    occurrences_other: "{{count}} cargos",
    confirm: "Confirmar",
    confirmed: "Marcado como suscripción",
    notASubscription: "No es una suscripción",
    dismissed: "Eliminado de suscripciones",
    remove: "Quitar",
    removed: "Quitado",
    restore: "Restaurar",
    restored: "Restaurado",
    summary: {
      monthly: "Mensual",
      annual: "Anualizado",
      count: "Suscripciones activas",
      fxExcluded: "{{count}} excluidas (sin tipo de cambio)",
    },
    filter: {
      active: "Activas",
      lapsed: "Caducadas",
      all: "Todas",
      allCategories: "Todas las categorías",
    },
    empty: {
      title: "Aún no hay cargos recurrentes",
      body: "Cuando un comercio te cobre varias veces, aparecerá aquí.",
    },
    status: {
      active: "Activa",
      lapsed: "Caducada",
    },
    cadence: {
      WEEKLY: "Semanal",
      MONTHLY: "Mensual",
      QUARTERLY: "Trimestral",
      ANNUAL: "Anual",
      unknown: "Desconocida",
    },
    due: {
      today: "vence hoy",
      inDays: "vence en {{count}} d",
      agoDays: "vencido hace {{count}} d",
    },
    rename: {
      label: "Renombrar suscripción",
      renamed: "Suscripción renombrada",
      custom: "nombre personalizado",
    },
    merge: {
      mergeInto: "Combinar con otra suscripción",
      pickTarget: "Elige una suscripción…",
      merged: "Suscripciones combinadas",
      unmerge: "Deshacer combinación",
      unmerged: "Combinación deshecha",
      tombstoneHint: "Integrada en otra suscripción: sus cargos cuentan para esa.",
      unknownTarget: "otra suscripción",
      mergedCountHint_one: "{{count}} combinada con otra — gestionar",
      mergedCountHint_other: "{{count}} combinadas con otras — gestionar",
      targetMissing: "Falta el destino de la combinación",
      stale: "Esta combinación no está surtiendo efecto: prueba a deshacerla y combinar de nuevo.",
      dismissBlocked: "Primero deshaz la combinación de las filas integradas en esta.",
    },
    split: {
      splitByAmount: "Dividir por importe — una suscripción por precio",
      split: "Dividida en una suscripción por importe",
      unsplit: "Deshacer división",
      unsplitDone: "División deshecha",
      markerHint: "Dividida por importe — cada precio recurrente es su propia suscripción.",
      nothingToSplit: "Estos cargos no se repiten con dos o más importes distintos.",
    },
    pager: {
      prev: "Anterior",
      next: "Siguiente",
      pageOf: "Página {{page}} de {{total}}",
    },
  },

  // Passive Income (#77)
  passiveIncome: {
    title: "Ingresos pasivos",
    subtitle: "Dividendos, cupones, alquileres, intereses y prestaciones previstos junto a lo que realmente recibiste",
    loadFailed: "No se pudieron cargar los ingresos pasivos.",
    horizon: "Horizonte de proyección",
    months_one: "{{count}} mes",
    months_other: "{{count}} meses",
    kpi: {
      next12m: "Próximos 12 meses",
      split: "{{investment}} inversiones · {{other}} otros",
      monthlyAverage: "Promedio mensual",
      yieldOnValue: "Rendimiento sobre valor",
      yieldHint: "Solo ingresos de inversiones",
      essentialsCoverage: "Gastos esenciales cubiertos",
      essentialsHint: "de {{amount}} gastados en los últimos 12 meses",
      noEssentials: "Sin gastos esenciales registrados",
      dataCoverage: "Cobertura de datos",
      dataCoverageValue: "{{configured}} de {{total}}",
      dataCoverageHint: "posiciones generadoras de ingresos configuradas",
    },
    chart: {
      title: "Ingresos reales vs previstos",
      actual: "Real",
      today: "Hoy",
    },
    bucket: {
      dividend: "Dividendos",
      coupon: "Cupones",
      rent: "Alquileres",
      interest: "Intereses",
      other: "Asignaciones y prestaciones",
    },
    frequency: {
      WEEKLY: "Semanal",
      MONTHLY: "Mensual",
      QUARTERLY: "Trimestral",
      SEMIANNUAL: "Semestral",
      ANNUAL: "Anual",
      AT_MATURITY: "Al vencimiento",
      IRREGULAR: "Irregular",
      MIXED: "Mixta",
      NONE: "Sin pagos",
    },
    incomeType: {
      DIVIDEND: "Dividendo",
      FIXED_COUPON: "Bono de tasa fija",
      FLOATING_COUPON: "Bono de tasa variable",
      INFLATION_LINKED: "Bono ligado a la inflación",
      RENT: "Alquiler",
      INTEREST: "Intereses",
      CUSTOM_YIELD: "Rendimiento",
      FIXED_AMOUNT: "Importe fijo",
      NONE: "Sin ingresos",
    },
    source: {
      AUTO: "Automático",
      OVERRIDE: "Personalizado",
      MANUAL: "Manual",
      MISSING: "Faltante",
      MIXED: "Mixto",
    },
    status: {
      OK: "OK",
      MATURED_UNREDEEMED: "Vencido: registra el reembolso",
      ENDED: "Finalizado",
      STALE_RATE: "La tasa puede estar desactualizada",
    },
    yearly: {
      title: "Resumen anual",
      source: "Origen",
      year: "Año {{n}}",
      total: "Total",
    },
    upcoming: {
      title: "Próximos pagos",
      empty: "Aún no se esperan pagos.",
    },
    breakdown: {
      filters: {
        all: "Todo",
        assets: "Posiciones",
        streams: "Flujos",
        attention: "Requiere atención",
      },
      search: "Buscar posiciones o flujos",
      filter: "Filtrar",
      noMatches: "Nada coincide con tu búsqueda.",
      showing: "{{from}}–{{to}} de {{total}}",
      prev: "Página anterior",
      next: "Página siguiente",
      title: "Desglose por posición o flujo",
      description: "Previsto para los próximos {{count}} meses",
      empty: "Aún no hay ingresos configurados. Añade condiciones de ingresos a tus posiciones o un flujo de ingresos.",
      holding: "Posición / flujo",
      type: "Tipo",
      rateOrAmount: "Tasa / importe",
      frequency: "Frecuencia",
      nextPayment: "Próximo pago",
      endDate: "Termina",
      horizonTotal: "Previsto",
      mixed: "Mixto",
      accounts_one: "{{count}} cuenta",
      accounts_other: "{{count}} cuentas",
      showAccounts_one: "Mostrar {{count}} cuenta",
      showAccounts_other: "Mostrar {{count}} cuentas",
      hideAccounts: "Ocultar cuentas",
      editGroup: "Editar las condiciones de ingresos de todas las posiciones de {{name}}",
      cashSummary: "Saldo {{balance}} · {{monthly}}/mes",
      quantity: "{{value}} unidades",
      view: {
        label: "Vista del desglose",
        grouped: "Por activo",
        flat: "Por cuenta",
      },
    },
    ladder: {
      title: "Escalera de vencimientos",
      description: "Principal que se devuelve por año (no cuenta como ingreso)",
      empty: "Ningún bono vence en este horizonte.",
    },
    streams: {
      title: "Otros flujos de ingresos",
      description: "Asignaciones y prestaciones públicas no vinculadas a un activo",
      add: "Añadir flujo",
      empty: "Aún no hay flujos de ingresos.",
      noCategories: "Crea una categoría Asignación o Prestaciones públicas en el grupo Ingresos pasivos para añadir flujos.",
    },
    missing: {
      showAll: "Ver todas ({{count}})",
      showLess: "Ver menos",
      title_one: "{{count}} posición no tiene datos de ingresos",
      title_other: "{{count}} posiciones no tienen datos de ingresos",
      description: "Añade sus condiciones de ingresos o márcalas como sin distribución para completar la proyección.",
    },
    detached: {
      searchAsset: "Buscar posiciones…",
      noAssets: "No hay posiciones sin condiciones de ingresos.",
      title: "Condiciones de ingresos desvinculadas",
      description: "Estas condiciones pertenecían a posiciones recreadas tras corregir una importación. Vuelve a vincularlas a la posición correcta o descártalas.",
      unnamed: "Posición sin nombre",
      detachedOn: "desvinculado el {{date}}",
      reattach: "Volver a vincular",
      discard: "Descartar",
      pickAsset: "Elige una posición",
      confirmAttach: "Vincular",
      attached: "Condiciones de ingresos vinculadas",
      attachFailed: "No se pudieron vincular las condiciones de ingresos.",
      discardTitle: "¿Descartar estas condiciones de ingresos?",
      discardConfirm: "Se eliminarán de forma permanente.",
      discarded: "Condiciones de ingresos descartadas",
      discardFailed: "No se pudieron descartar las condiciones de ingresos.",
    },
  },
  incomeTerms: {
    faceValueHint_one: "{{units}} unidad en cartera · {{perUnit}} por unidad",
    faceValueHint_other: "{{units}} unidades en cartera · {{perUnit}} por unidad",
    pickDate: "Elige una fecha",
    clearDate: "Borrar fecha",
    action: "Condiciones de ingresos",
    actionConfigured: "Condiciones de ingresos (configuradas)",
    title: "Condiciones de ingresos — {{name}}",
    addStreamTitle: "Añadir flujo de ingresos",
    editStreamTitle: "Editar flujo de ingresos",
    assetDescription: "Indica a Bliss lo que paga esta posición para proyectar tus ingresos pasivos. Importes brutos.",
    streamDescription: "Un ingreso recurrente no vinculado a un activo, como una asignación o una pensión pública.",
    notIncomeCapable: "Esta posición no puede generar ingresos pasivos.",
    autoTitle: "Datos automáticos de dividendos",
    autoSummary: "{{count}} pagos en los últimos 12 meses ({{frequency}}) · {{amount}} por acción · última fecha ex {{date}}",
    autoNone: "Sin dividendos en los últimos 12 meses (p. ej. un fondo de acumulación). Proyecta cero y no se marca como faltante.",
    autoUnavailable: "Aún no hay datos fiables de dividendos. Añade un valor personalizado abajo.",
    override: "Personalizar los dividendos automáticos",
    notDistributing: "No distribuye ingresos",
    groupTitle_one: "Condiciones de ingresos — {{name}} ({{count}} cuenta)",
    groupTitle_other: "Condiciones de ingresos — {{name}} ({{count}} cuentas)",
    applyToAllHoldings_one: "Aplicar a todas las posiciones de {{symbol}} ({{count}})",
    applyToAllHoldings_other: "Aplicar a las {{count}} posiciones de {{symbol}}",
    appliesToHoldings_one: "Se aplica a {{count}} posición de {{symbol}}",
    appliesToHoldings_other: "Se aplica a {{count}} posiciones de {{symbol}}",
    mixedTitle: "Estas posiciones no comparten las mismas condiciones",
    mixedDescription: "Cada cuenta de {{symbol}} tiene ahora sus propios datos de ingresos. Elige una cuenta como punto de partida.",
    mixedAccount: "Cuenta",
    mixedUseSame: "Usar las mismas condiciones para todas",
    mixedEditOne: "Editar solo esta cuenta",
    removeFromAllConfirm_one: "Se eliminarán las condiciones de ingresos de {{count}} posición de {{symbol}}. Las acciones y los ETF vuelven a los datos automáticos.",
    removeFromAllConfirm_other: "Se eliminarán las condiciones de ingresos de las {{count}} posiciones de {{symbol}}. Las acciones y los ETF vuelven a los datos automáticos.",
    faceValuePerUnitGroupHint_one: "{{units}} unidad en {{count}} posición · {{total}} en total",
    faceValuePerUnitGroupHint_other: "{{units}} unidades en {{count}} posiciones · {{total}} en total",
    select: "Seleccionar…",
    none: "Ninguno",
    otherIndex: "Otro",
    namePlaceholder: "p. ej. Pensión pública",
    netRentHint: "Introduce el alquiler que realmente te queda tras gastos y vacancia.",
    previewAnnual: "≈ {{amount}} / año",
    previewNext: "próximo pago {{date}}",
    previewEnds: "termina en {{year}}",
    removeTerms: "Quitar condiciones",
    deleteStream: "Eliminar flujo",
    saved: "Condiciones de ingresos guardadas",
    deleted: "Condiciones de ingresos eliminadas",
    saveFailed: "No se pudieron guardar las condiciones de ingresos.",
    issuer: {
      GOVERNMENT: "Gobierno",
      CORPORATE: "Corporativo",
    },
    fields: {
      faceValueTotal: "Valor nominal total",
      incomeType: "Tipo de ingreso",
      issuerType: "Emisor",
      faceValuePerUnit: "Valor nominal por unidad",
      couponRate: "Tasa del cupón",
      realCoupon: "Cupón real",
      referenceIndex: "Índice de referencia",
      assumedIndexRate: "Tasa supuesta del índice",
      spread: "Diferencial",
      frequency: "Frecuencia",
      maturityDate: "Fecha de vencimiento",
      anchorPaymentDate: "Una fecha de pago",
      monthlyRent: "Alquiler mensual neto",
      annualIndexationPct: "Indexación anual",
      leaseStart: "Inicio del contrato",
      leaseEndDate: "Fin del contrato",
      apyPct: "TAE",
      yieldPct: "Rendimiento",
      orYieldPct: "…o rendimiento",
      dividendPerUnit: "Dividendo anual por acción",
      name: "Nombre",
      category: "Categoría",
      amountPerPayment: "Importe por pago",
      currency: "Moneda",
      startDate: "Fecha de inicio",
      endDate: "Fecha de fin",
    },
    errors: {
      required: "Obligatorio",
      invalid: "Valor no válido",
      number: "Introduce un número",
      negative: "No puede ser negativo",
      date: "Introduce una fecha válida",
      endBeforeStart: "Debe ser posterior a la fecha de inicio",
      currency: "Usa un código de 3 letras (p. ej. EUR)",
    },
  },
  maintenance: {
    fullRebuildSecuritiesStep: "También actualiza los datos de valores de tus acciones y ETF con datos faltantes o desactualizados.",
    securityData: {
      title: "Actualizar los datos de mis valores",
      description: "Vuelve a obtener perfil, dividendos y cotizaciones de todas tus acciones y ETF (resultados solo para acciones). Úsalo si el calendario de dividendos o el análisis de renta variable parecen incorrectos.",
      button: "Actualizar valores",
    },
    globalFundamentals: {
      title: "Actualizar fundamentales de todos los símbolos (global)",
      description: "Actualiza la tabla SecurityMaster compartida para todos los símbolos de todos los inquilinos, no solo los tuyos. Más pesado que actualizar tus valores; úsalo tras un incidente del proveedor de datos.",
    },
  },

  // Manage Assets page (#81)
  manageAssets: {
    title: "Gestionar activos",
    subtitle: "Todos tus activos y pasivos en un solo lugar: precios, términos de ingresos, términos de deuda y clases de activo.",
    loadFailed: "No se pudieron cargar los activos. Inténtalo de nuevo.",
    assetClassHint: "Se aplica a todas las posiciones de {{symbol}}. Elige Automático para quitar la modificación.",
    searchPlaceholder: "Buscar por símbolo o nombre",
    empty: "Ningún activo coincide con estos filtros.",
    count: "{{count}} activos",
    count_one: "{{count}} activo",
    count_other: "{{count}} activos",
    loadMore: "Cargar más",
    loadingMore: "Cargando…",
    columns: {
      assetClass: "Clase de activo",
    },
    filters: {
      type: "Tipo",
      allTypes: "Todos los tipos",
      account: "Cuenta",
      allAccounts: "Todas las cuentas",
      assetClass: "Clase de activo",
      allAssetClasses: "Todas las clases",
      includeClosed: "Mostrar posiciones cerradas",
      clear: "Borrar filtros",
    },
    status: {
      debtTermsMissing: "Faltan términos de deuda",
      label: "Filtrar por estado",
      stale: "Precio desactualizado",
      incomeMissing: "Faltan términos de ingresos",
      dividendOverride: "Dividendo modificado",
      lotMismatch: "Discrepancia de lotes",
      assetClassOverridden: "Clase de activo modificada",
    },
    chips: {
      noPrice: "Sin precio aún",
    },
    actions: {
      addIncomeTerms: "Añadir términos de ingresos",
      addDebtTerms: "Añadir términos de deuda",
      menu: "Acciones para {{symbol}}",
      price: "Actualizar precio",
      history: "Historial de precios",
      assetClass: "Clase de activo",
      copyTrading: "Pasar a Copy Trading",
    },
    attention: {
      title: "{{count}} elementos requieren tu atención",
      title_one: "{{count}} elemento requiere tu atención",
      title_other: "{{count}} elementos requieren tu atención",
      allClear: "Todo al día",
      allClearHint: "Los precios están actualizados y cada préstamo y posición con ingresos tiene sus términos.",
      stale: "Precios por actualizar",
      debtTermsMissing: "Préstamos sin términos",
      incomeMissing: "Faltan términos de ingresos",
      lotMismatch: "Discrepancias de lotes por revisar",
    },
    sort: {
      label: "Ordenar",
      attention: "Primero lo que requiere atención",
      name: "A–Z",
    },
    detached: {
      title: "{{count}} conjuntos de términos de ingresos están desvinculados",
      title_one: "{{count}} conjunto de términos de ingresos está desvinculado",
      title_other: "{{count}} conjuntos de términos de ingresos están desvinculados",
      description: "Una reconstrucción de la cartera no pudo asociarlos a una posición. Vuelve a vincularlos o descártalos.",
      review: "Revisar",
      hide: "Ocultar",
    },
  },

  // Processing status (#100): header chip, page banners, Settings → Processing
  activity: {
    types: {
      PORTFOLIO_UPDATE: "Actualizando cartera",
      ANALYTICS_UPDATE: "Actualizando análisis",
      BANK_SYNC: "Sincronizando banco",
      IMPORT: "Importando transacciones",
      SECURITY_DATA: "Actualizando datos de mercado",
      SUBSCRIPTION_SCAN: "Analizando suscripciones",
      INSIGHTS: "Generando análisis con IA",
    },
    stages: {
      scheduling: "Programando",
      recalculating_lots: "Recalculando lotes",
      updating_cash: "Actualizando efectivo",
      valuing_assets: "Valorando activos",
      updating_debts: "Actualizando deudas",
      updating_analytics: "Actualizando análisis",
      fetching_bank: "Obteniendo transacciones bancarias",
      syncing_copies: "Sincronizando copias de eToro",
      classifying: "Clasificando transacciones",
      processing_file: "Procesando archivo",
      committing: "Guardando transacciones",
      refreshing_market_data: "Actualizando datos de mercado",
      scanning: "Analizando",
      generating_insights: "Generando análisis con IA",
    },
    triggers: {
      user_change: "Tu cambio",
      bank_sync: "Sincronización bancaria",
      import: "Importación",
      nightly: "Nocturno",
      manual_rebuild: "Reconstrucción",
      agent: "Agente de IA",
      auto_refresh: "Actualización automática",
    },
    states: {
      queued: "En cola",
      running: "Actualizando",
      stalled: "Tarda más de lo habitual",
      completed: "Completado",
      failed: "Fallido",
    },
    chip: {
      queued: "En cola",
      running: "Actualizando",
      stalled: "Tarda más de lo habitual",
      failed: "Error al actualizar",
      ariaLabel: "Estado del procesamiento en segundo plano",
      title: "Procesamiento en segundo plano",
      empty: "Todo está actualizado",
      lastUpdated: "Última actualización {{time}}",
      jobs: "{{count}} tareas",
      workerOffline: "El proceso en segundo plano está desconectado. Las tareas en cola empezarán cuando vuelva.",
      failedHint: "Error {{code}}. Los administradores pueden ver los detalles en Ajustes → Procesamiento.",
      pending: "Iniciando…",
    },
    banner: {
      queued: "Las cifras de esta página se recalcularán en breve ({{label}}). Se actualizarán automáticamente.",
      running: "Se están recalculando las cifras de esta página ({{label}}). Se actualizarán automáticamente.",
      runningProgress: "Se están recalculando las cifras de esta página ({{label}}, {{progress}} %). Se actualizarán automáticamente.",
      stalled: "El recálculo está tardando más de lo habitual ({{label}}). Las cifras pueden estar desactualizadas.",
      failed: "La última actualización de los datos de esta página falló ({{label}}). Las cifras pueden estar desactualizadas.",
      updated: "Actualizado {{time}}",
    },
    time: {
      justNow: "ahora mismo",
      underSecond: "< 1 s",
      minutesAgo: "hace {{count}} min",
      hoursAgo: "hace {{count}} h",
      daysAgo: "hace {{count}} d",
      seconds: "{{count}} s",
      minutes: "{{count}} min",
      hours: "{{count}} h",
    },
    processing: {
      title: "Procesamiento",
      description: "Trabajo en segundo plano sobre tus datos: lo que se ejecuta ahora, las últimas 24 horas y las reconstrucciones.",
      liveTitle: "En curso",
      liveEmpty: "No hay nada en ejecución. Tus datos están actualizados.",
      recentTitle: "Últimas 24 horas",
      recentEmpty: "No ha habido trabajo en segundo plano en las últimas 24 horas.",
      rebuildsTitle: "Reconstrucciones recientes",
      unavailable: "El estado del procesamiento no está disponible ahora mismo.",
      workerOffline: "El proceso en segundo plano está desconectado. Las tareas en cola empezarán cuando vuelva.",
      elapsed: "en ejecución desde hace {{time}}",
      queuedFor: "en cola desde hace {{time}}",
      took: "duró {{time}}",
      finished: "terminó {{time}}",
      errorCode: "Error {{code}}",
      steps_one: "{{count}} paso",
      steps_other: "{{count}} pasos",
    },
    notification: {
      failed_one: "{{count}} actualización en segundo plano falló",
      failed_other: "{{count}} actualizaciones en segundo plano fallaron",
    },
    maintenance: {
      seeProgress: "Ver progreso",
      seeProgressHint: "El progreso en directo y el historial de reconstrucciones están en Procesamiento.",
    },
  },

  // Enable Banking (#132)
  // eToro copy trading (#143)
  etoro: {
    section: {
      title: "Copy trading de eToro",
      description: "Sigue el valor y la composición de tus copias de eToro. Bliss las lee con una clave de lectura de tu propia cuenta de eToro. Nunca opera ni crea transacciones.",
      connect: "Conectar eToro",
      empty: "Todavía no hay ninguna cuenta de eToro conectada.",
      guide: "Cómo crear una clave de lectura",
      loadFailed: "No se pudieron cargar tus conexiones de eToro.",
    },
    status: {
      ACTIVE: "Conectada",
      NEEDS_RECONNECT: "Necesita una clave nueva",
    },
    connection: {
      account: "Cuenta de Bliss",
      noAccount: "Sin cuenta",
      key: "Clave",
      lastSync: "Última sincronización",
      never: "Nunca",
      lastSyncFailed: "La última sincronización falló ({{code}})",
      syncNow: "Sincronizar ahora",
      syncStarted: "Sincronización iniciada. Los valores se actualizarán en unos minutos.",
      cooldown: "Sincronizado hace poco. Inténtalo de nuevo en {{minutes}} min.",
      replaceKey: "Cambiar clave",
      remove: "Eliminar",
      removeTitle: "¿Eliminar esta conexión de eToro?",
      removeDescription: "Bliss deja de actualizar tus copias. Tus posiciones de Copy Trading y su historial se conservan.",
      removeConfirm: "Eliminar",
      removed: "Conexión de eToro eliminada",
      copies: "Copias",
      noCopies: "No hay copias en esta cuenta.",
    },
    copy: {
      closed: "Cerrada en eToro",
      linkedTo: "Vinculada a {{symbol}}",
      notLinked: "Sin vincular",
      notLinkedHint: "Registra esta copia como posición de Copy Trading con el ticker {{username}} en esta cuenta, o pasa un fondo existente a Copy Trading en Gestionar activos.",
      startedAt: "Desde {{date}}",
    },
    dialog: {
      title: "Conectar eToro",
      replaceTitle: "Cambiar la clave de eToro",
      description: "Crea una clave de lectura en eToro (Ajustes → Trading → Gestión de claves API) y pega los dos valores. Bliss rechaza las claves que pueden operar.",
      apiKey: "Clave API",
      userKey: "Clave de usuario",
      userKeyHint: "Se guarda cifrada y no se vuelve a mostrar.",
      account: "Cuenta de Bliss",
      accountHint: "La cuenta donde registras tus copias de eToro.",
      accountPlaceholder: "Elige una cuenta",
      submit: "Conectar",
      replaceSubmit: "Guardar clave",
      checking: "Comprobando con eToro…",
      successTitle: "Conectado como {{username}}",
      successCopies_one: "{{count}} copia encontrada",
      successCopies_other: "{{count}} copias encontradas",
      noCopies: "Todavía no hay copias en esta cuenta.",
      done: "Hecho",
      cancel: "Cancelar",
    },
    errors: {
      ETORO_WRITE_SCOPE: "Esta clave puede operar. Crea una clave de lectura en eToro y usa esa.",
      ETORO_KEY_INVALID: "eToro no aceptó esta clave. Revisa los dos valores y que no haya caducado.",
      ETORO_UNAVAILABLE: "No se pudo contactar con eToro. Inténtalo más tarde.",
      ETORO_RATE_LIMITED: "eToro está limitando las peticiones. Inténtalo en un minuto.",
      ETORO_ALREADY_CONNECTED: "Esta cuenta de eToro ya está conectada.",
      ETORO_DIFFERENT_LOGIN: "Esta clave pertenece a otra cuenta de eToro.",
      KEYS_REQUIRED: "Introduce las dos claves.",
      ACCOUNT_REQUIRED: "Elige una cuenta de Bliss.",
      generic: "Algo salió mal. Inténtalo de nuevo.",
    },
    badge: {
      linked: "Vinculada a eToro",
      needsReconnect: "La clave de eToro necesita cambiarse",
      closed: "Copia cerrada en eToro",
      notLinked: "Sin vincular a eToro",
      lastValue: "Valor de eToro del {{date}}",
    },
    convert: {
      title: "Pasar a Copy Trading",
      description: "Mueve {{symbol}} a la categoría Copy Trading. Sus transacciones, condiciones de ingresos e historial no cambian. Cuando tu cuenta de eToro esté conectada, Bliss seguirá el valor y la composición de la copia.",
      username: "Usuario de eToro del inversor que copias",
      usernamePlaceholder: "@inversor",
      pickCopy: "Elige la copia",
      otherInvestor: "Otro inversor",
      matched: "coincide con el nombre",
      otherAccount: "Tu conexión de eToro usa la cuenta {{account}}. Este activo está en otra cuenta, así que no se vinculará al cambiarlo: mueve antes sus transacciones a {{account}}.",
      submit: "Cambiar",
      success: "{{symbol}} es ahora una posición de Copy Trading",
      errors: {
        INVALID_USERNAME: "Introduce un usuario de eToro válido.",
        COPY_HOLDING_EXISTS: "Esta cuenta ya tiene una posición para ese inversor.",
        COPY_TRADING_CATEGORY_MISSING: "Falta la categoría Copy Trading. Pide a tu administrador de Bliss que la añada.",
        generic: "No se pudo cambiar esta posición. Inténtalo de nuevo.",
      },
    },
  },
  enableBanking: {
    connect: {
      button: "Conectar banco de la UE (Enable Banking)",
      title: "Conectar un banco europeo",
      description: "Elige tu banco. Te llevaremos a su web para aprobar el acceso de solo lectura a través de Enable Banking.",
      search: "Buscar bancos",
      loading: "Cargando bancos...",
      loadFailed: "No se pudo cargar la lista de bancos. Inténtalo más tarde.",
      noBanks: "No se encontraron bancos para los países de tu espacio.",
      startDate: "Las transacciones se importarán desde el",
      consentDays_one: "El acceso dura hasta {{count}} día; después tendrás que volver a conectar.",
      consentDays_other: "El acceso dura hasta {{count}} días; después tendrás que volver a conectar.",
      continue: "Continuar al banco",
      redirecting: "Redirigiendo...",
      errorCountryNotEnabled: "El país de este banco no está habilitado en tu espacio.",
      errorUnknownBank: "Este banco ya no está disponible. Elige otro.",
      errorGeneric: "No se pudo iniciar la conexión con el banco. Inténtalo más tarde.",
    },
    callback: {
      reconnectedTitle: "Reconectado — sincronizando",
      reconnectedDesc: "Se renovó el acceso a tu banco y ha comenzado una sincronización.",
      errorTitle: "Falló la conexión con el banco",
      invalid_state: "El enlace de conexión caducó o ya se usó. Empieza de nuevo desde Cuentas.",
      denied: "No se concedió el acceso en tu banco. No se conectó nada.",
      exchange_failed: "Tu banco no confirmó la conexión. Inténtalo de nuevo en unos minutos.",
      not_enabled: "Enable Banking no está configurado para tu espacio. Un administrador puede añadirlo en Ajustes → Sincronización bancaria.",
      unknown: "Algo salió mal al conectar tu banco.",
    },
    mapping: {
      title: "Vincula tus cuentas bancarias",
      description: "Elige en qué cuenta de Bliss se sincroniza cada cuenta de {{bank}}.",
      loading: "Cargando cuentas...",
      loadFailed: "No se pudo cargar esta conexión. Inténtalo más tarde.",
      unnamed: "Cuenta bancaria",
      balance: "Saldo {{amount}}",
      syncInto: "Sincronizar en",
      existingAccounts: "Cuentas existentes",
      createNew: "Crear cuenta nueva",
      dontSync: "No sincronizar",
      linkedPlaid: "sincronizada con Plaid",
      linkedEnableBanking: "sincronizada con otra conexión",
      switchHint: "Esta cuenta se sincroniza con otra conexión. Vincularla aquí traslada su sincronización a este banco; su historial se conserva.",
      conflict: "Ya se sincroniza a través de la conexión de otra persona — autoriza una cuenta conjunta con un solo titular.",
      newName: "Nombre de la cuenta",
      newBank: "Banco",
      newCountry: "País",
      newCurrency: "Moneda",
      createBankOption: "Añadir \"{{name}}\"",
      noAccounts: "Tu banco no devolvió ninguna cuenta.",
      submit: "Vincular cuentas",
      submitting: "Vinculando...",
      successTitle: "Cuentas vinculadas — sincronizando",
      successDesc_one: "Se sincronizará {{count}} cuenta. Ha comenzado la primera sincronización.",
      successDesc_other: "Se sincronizarán {{count}} cuentas. Ha comenzado la primera sincronización.",
      successNoneDesc: "No se vinculó ninguna cuenta. Puedes vincularlas más tarde desde esta conexión.",
      errorAlreadyConnected: "Una de estas cuentas bancarias ya se sincroniza a través de otra conexión.",
      errorDuplicate: "Dos cuentas bancarias no pueden sincronizarse en la misma cuenta de Bliss.",
      errorCreateIncomplete: "Completa el nombre, banco, país y moneda de cada cuenta nueva.",
      errorGeneric: "No se pudieron vincular las cuentas. Inténtalo de nuevo.",
      switchTitle: "¿Cambiar el proveedor de sincronización?",
      switchDesc: "Estas cuentas dejarán de sincronizarse con su proveedor actual y pasarán a sincronizarse con Enable Banking. Su historial se conserva.",
      switchFrom: "Actualmente sincronizada con {{provider}} ({{bank}})",
      switchConfirm: "Cambiar y vincular",
      providerPlaid: "Plaid",
      providerEnableBanking: "Enable Banking",
    },
    card: {
      title: "Conexión de Enable Banking",
      statusActive: "Activa",
      statusExpiring: "Caduca pronto",
      statusExpired: "Caducada",
      statusError: "Error",
      statusDisconnected: "Desconectada",
      statusNeedsMapping: "Falta vincular",
      expiringDesc: "El acceso al banco termina pronto. Vuelve a conectar para seguir sincronizando.",
      expiredDesc: "El acceso al banco ha terminado. Vuelve a conectar para reanudar la sincronización.",
      errorDesc: "La última sincronización falló. Inténtalo más tarde o vuelve a conectar.",
      needsMappingDesc: "Elige qué cuentas de Bliss alimenta este banco antes de que pueda sincronizar.",
      bank: "Banco",
      accessExpires: "El acceso caduca",
      expiresIn_one: "{{date}} (queda {{count}} día)",
      expiresIn_other: "{{date}} (quedan {{count}} días)",
      lastSync: "Última sincronización",
      balanceAsOf: "a {{date}}",
      syncNow: "Sincronizar ahora",
      syncStarted: "Sincronización iniciada",
      syncStartedDesc: "Las nuevas transacciones aparecerán en breve.",
      syncFailed: "No se pudo iniciar la sincronización",
      syncNotActive: "Vuelve a conectar este banco antes de sincronizar.",
      syncNoAccounts: "Vincula al menos una cuenta antes de sincronizar.",
      budgetTitle: "Límite diario de actualizaciones alcanzado",
      budgetDesc: "Tu banco solo permite unas pocas actualizaciones al día. Podrás sincronizar de nuevo después de {{time}}.",
      budgetDescNoTime: "Tu banco solo permite unas pocas actualizaciones al día. Inténtalo mañana.",
      reconnect: "Reconectar",
      reconnectOnlyAuthoriser: "Solo la persona que autorizó esta conexión puede reconectarla.",
      reconnectFailed: "No se pudo iniciar la reconexión. Inténtalo más tarde.",
      mapAccounts: "Vincular cuentas",
      manageAccounts: "Gestionar cuentas",
      disconnect: "Desconectar",
      disconnecting: "Desconectando...",
      disconnectOnlyAdmin: "Solo un administrador o la persona que autorizó esta conexión puede desconectarla.",
      disconnectTitle: "¿Desconectar {{bank}}?",
      disconnectDesc: "La sincronización se detiene y se revoca el acceso al banco. Tus cuentas y su historial de transacciones se conservan.",
      disconnected: "Banco desconectado",
      disconnectedDesc: "La sincronización se detuvo. Tus cuentas y su historial se conservan.",
      disconnectFailed: "No se pudo desconectar",
      statusPaused: "En pausa",
      pausedDesc: "En pausa: faltan las credenciales.",
      pausedAdminLink: "Configurar la sincronización bancaria",
      pausedAskAdmin: "Pide a un administrador que añada las credenciales de Enable Banking.",
    },
    pending: {
      message: "{{bank}} está conectado, pero aún no hay ninguna cuenta vinculada. Elige qué cuentas sincronizar.",
    },
    detail: {
      badge: "Enable Banking",
      deleteBlockedHint: "Primero desconecta esta conexión bancaria (usa \"Desconectar\" arriba) antes de eliminar la cuenta.",
    },
    credentials: {
      title: "Enable Banking (bancos de la UE)",
      intro: "Sincroniza automáticamente cuentas de bancos de la UE con tu propia aplicación de Enable Banking. Una aplicación gratuita puede vincular hasta 5 cuentas.",
      guideLink: "Leer la guía de configuración",
      callbackLabel: "URL de retorno",
      callbackHint: "Registra esta URL como URL de redirección en tu aplicación de Enable Banking.",
      copy: "Copiar",
      copied: "Copiado",
      appIdLabel: "Id de la aplicación",
      appIdInvalid: "El id de la aplicación es un UUID, como 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      keyLabel: "Clave privada",
      save: "Guardar y verificar",
      saving: "Verificando...",
      cancel: "Cancelar",
      statusVERIFIED: "Verificadas",
      statusUNVERIFIED: "Sin verificar",
      statusINVALID: "No válidas",
      unverifiedDesc: "No se pudo contactar con Enable Banking para comprobar estas credenciales. Están guardadas; usa Volver a verificar para comprobarlas de nuevo.",
      invalidDesc: "Enable Banking ha rechazado estas credenciales. Las sincronizaciones programadas están en pausa hasta que las vuelvas a verificar o las sustituyas.",
      callbackMissing: "La URL de retorno aún no está registrada en esta aplicación. Las conexiones bancarias fallarán hasta que lo esté.",
      appId: "Id de la aplicación",
      fingerprint: "Huella de la clave",
      keyBits: "RSA de {{bits}} bits",
      lastValidated: "Última verificación",
      never: "Nunca",
      linkedAccounts: "Cuentas vinculadas",
      linkedAccountsValue: "{{used}} de {{limit}}",
      activeConnections: "Conexiones activas",
      replace: "Sustituir credenciales",
      reverify: "Volver a verificar",
      remove: "Eliminar",
      replaceHint: "Para cambiar solo la clave, mantén el id de la aplicación y sube el nuevo archivo.",
      savedTitle: "Enable Banking está configurado",
      savedDesc: "Tu espacio ya puede conectar bancos de la UE desde Cuentas.",
      savedUnverifiedDesc: "Guardadas, pero no se pudo contactar con Enable Banking para verificarlas. Usa Volver a verificar más tarde.",
      verifiedTitle: "Credenciales verificadas",
      stillInvalidTitle: "Enable Banking sigue rechazando estas credenciales",
      stillUnverifiedTitle: "No se pudo contactar con Enable Banking",
      removedTitle: "Credenciales eliminadas",
      removedDesc: "Las conexiones quedan en pausa hasta que se vuelvan a añadir credenciales.",
      errorINVALID_CREDENTIALS: "Enable Banking ha rechazado estas credenciales. Comprueba que la clave privada pertenece a esta aplicación.",
      errorSANDBOX_APP: "Es una aplicación de sandbox. Crea una aplicación de producción en modo restringido.",
      errorINVALID_APP_ID: "El id de la aplicación es un UUID, como 6f0c1a2b-3c4d-4e5f-8a9b-0c1d2e3f4a5b.",
      errorGeneric: "No se pudieron guardar las credenciales. Inténtalo de nuevo.",
      loadFailed: "No se pudieron cargar los ajustes de Enable Banking.",
      confirmAppChangeTitle: "¿Cambiar la aplicación de Enable Banking?",
      confirmAppChangeDesc_one: "{{count}} conexión dejará de sincronizarse hasta que se vuelva a conectar. Se conservan sus cuentas y su historial.",
      confirmAppChangeDesc_other: "{{count}} conexiones dejarán de sincronizarse hasta que se vuelvan a conectar. Se conservan sus cuentas y su historial.",
      confirmRemoveTitle: "¿Eliminar las credenciales de Enable Banking?",
      confirmRemoveDesc_one: "{{count}} conexión quedará en pausa hasta que se vuelvan a añadir credenciales. Se conservan las cuentas, los vínculos y las transacciones.",
      confirmRemoveDesc_other: "{{count}} conexiones quedarán en pausa hasta que se vuelvan a añadir credenciales. Se conservan las cuentas, los vínculos y las transacciones.",
      confirmContinue: "Continuar",
      pausedBanner_one: "{{count}} conexión está en pausa hasta que añadas tus credenciales de Enable Banking.",
      pausedBanner_other: "{{count}} conexiones están en pausa hasta que añadas tus credenciales de Enable Banking.",
      historyTitle: "Historial de cambios",
      historyEmpty: "Aún no hay cambios.",
      historySET: "Configuradas",
      historyREPLACED: "Sustituidas",
      historyKEY_ROTATED: "Clave cambiada",
      historyREMOVED: "Eliminadas",
      historyBy: "por {{name}}",
      historyUnknownUser: "un antiguo miembro",
      notification: "Las credenciales de Enable Banking necesitan atención",
      setupLink: "Configurar la sincronización de bancos de la UE",
    },
    keyInput: {
      drop: "Suelta aquí el archivo .pem de Enable Banking",
      choose: "Elegir archivo",
      pasteInstead: "Pegar en su lugar",
      uploadInstead: "Subir un archivo en su lugar",
      pasteLabel: "Clave privada (PEM)",
      valid: "Clave privada RSA válida · {{bits}} bits",
      clear: "Quitar",
      readFailed: "No se pudo leer este archivo.",
      errorKEY_NOT_PEM: "No es una clave privada PEM.",
      errorKEY_PUBLIC: "Es una clave pública. Usa la clave privada (.pem) que te dio Enable Banking.",
      errorKEY_CERTIFICATE: "Es un certificado, no una clave privada.",
      errorKEY_NOT_RSA: "Solo se admiten claves privadas RSA.",
      errorKEY_ENCRYPTED: "No se admiten claves protegidas con contraseña. Usa el .pem sin cifrar de Enable Banking.",
      errorKEY_TRUNCATED: "La clave parece incompleta: falta la línea END o el texto está cortado.",
      errorKEY_TOO_LARGE: "Ocupa más de 16 KB, demasiado para una clave privada.",
      errorKEY_TOO_SMALL: "Las claves RSA deben tener al menos 2048 bits.",
    },
    settings: {
      historyDaysHint: "También se aplica a las conexiones de Enable Banking.",
    },
  },
  // Installable PWA (#155)
  pwa: {
    install: {
      button: "Instalar app",
      settingsTitle: "App de Bliss",
      settingsDescription: "Instala Bliss para abrirlo en su propia ventana, desde la pantalla de inicio, el Dock o la barra de tareas.",
      bannerTitle: "Instala la app de Bliss",
      bannerDescription: "Abre Bliss en su propia ventana, desde la pantalla de inicio, el Dock o la barra de tareas.",
      dismiss: "Descartar",
      iosTitle: "Añade Bliss a tu pantalla de inicio",
      iosStep1: "Toca el botón Compartir en la barra del navegador.",
      iosStep2: "Desplázate hacia abajo y toca «Añadir a pantalla de inicio».",
      iosStep3: "Toca «Añadir». Bliss aparecerá en tu pantalla de inicio.",
      iosSignInNote: "La app no comparte la sesión de tu navegador, así que inicias sesión una vez dentro de la app.",
      done: "Entendido",
    },
    update: {
      reload: "Recargar",
    },
    banks: {
      desktopOnly: "Conecta y reconecta bancos desde un navegador de escritorio. Las transacciones sincronizadas se pueden seguir revisando aquí.",
    },
    offline: {
      title: "Estás sin conexión",
      description: "Bliss necesita conexión para mostrar tus datos. Tus cifras volverán a cargarse en cuanto vuelvas a estar en línea.",
      retry: "Reintentar",
    },
  },
  // Onboarding wizard (#154): every step, namespaced
  onboarding: {
    welcome: {
      title: "Bienvenido a",
      subtitle: "Vamos a personalizar tu experiencia",
      countries: "Tus países",
      currencies: "Tus monedas",
    },
    connect: {
      title: "Conecta tus cuentas",
      subtitle: "Vincula un banco para sincronizar automáticamente, importa una hoja de cálculo o añade cuentas manualmente",
      bankTitle: "Conecta tu banco",
      bankDescription: "Elige el proveedor que cubre tu banco. Puedes añadir el otro más adelante.",
      learnMore: "Más información",
      plaid: {
        title: "Plaid — bancos de EE. UU., Canadá y Reino Unido",
        description: "Vincula tus cuentas bancarias de forma segura con Plaid para sincronizar las transacciones automáticamente.",
        button: "Conectar cuenta bancaria",
        notConfigured: "Plaid no está configurado en este servidor.",
        notConfiguredHint: "El administrador del servidor añade las claves de Plaid; la guía explica cómo.",
        error: "No se pudo conectar con Plaid, inténtalo más tarde.",
      },
      enableBanking: {
        title: "Enable Banking — bancos de la UE",
        description: "Vincula bancos de la UE mediante consentimiento PSD2, con tu propia aplicación de Enable Banking.",
        connect: "Conectar banco de la UE",
        setup: "Configurar la sincronización de bancos de la UE",
        adminOnly: "Un administrador del espacio de trabajo puede configurar la sincronización de bancos de la UE en Ajustes.",
      },
      setup: {
        title: "Configurar la sincronización de bancos de la UE",
        description: "Bliss se conecta a bancos de la UE a través de tu propia aplicación de Enable Banking. Añade su ID y su clave privada: Bliss los comprueba antes de guardarlos y después eliges tu banco.",
        needTitle: "Qué necesitas",
        needAccount: "Una cuenta de Enable Banking",
        needApp: "Una aplicación de producción en modo restringido",
        needCallback: "La URL de retorno de abajo registrada en esa aplicación",
        limit: "El modo restringido vincula hasta 5 cuentas bancarias propias.",
        guide: "Guía paso a paso",
      },
      importTitle: "Importar una hoja de cálculo",
      importDescription: "Sube un archivo CSV o Excel con tus transacciones.",
    },
    accounts: {
      title: "Añade tus bancos y cuentas",
      subtitle: "Elige los bancos que usas y añade una cuenta para cada uno. Puedes completar los números de cuenta más tarde.",
      selectBanks: "Selecciona tus bancos",
      addDifferentBank: "Añadir otro banco",
      bankName: "Nombre del banco",
      account: "Cuenta",
      addAccount: "Añadir cuenta",
      removeAccount: "Eliminar cuenta",
      removeBank: "Eliminar banco",
      bankCap: "Puedes añadir hasta {{count}} bancos aquí; podrás añadir más después.",
      pickCountry: "Elige el país de cada cuenta; por defecto es {{country}}.",
      createdIn: "Las cuentas se crearán en {{country}}.",
      skip: "Omitir por ahora",
      create_one: "Crear {{count}} cuenta",
      create_other: "Crear {{count}} cuentas",
    },
    errors: {
      noTenant: "No se encontró el espacio de trabajo",
      tenantMissing: "Falta el nombre o el plan del espacio de trabajo. Contacta con soporte.",
      savePreferences: "No se pudieron guardar tus preferencias. Inténtalo de nuevo.",
      noUser: "No se pudo identificar tu usuario. Inténtalo de nuevo.",
      setupAccounts: "No se pudieron configurar tus cuentas. Inténtalo de nuevo.",
    },
  },
};

export default es;
